"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const decimal_js_1 = require("decimal.js");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const webSocket_1 = require("rxjs/webSocket");
const trade_token_lib_1 = require("trade_token_lib");
const trade_utils_lib_1 = require("trade_utils_lib");
const ExchangeID_1 = require("../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../ExchangeAPIAdapter/TradeTypeDef");
const OrderDescUtils_1 = require("../MarketTradeDesc/OrderDescUtils");
const Macro_1 = require("../Tools/Macro");
const TradeUtils_1 = require("../Tools/TradeUtils");
const TradingBotResConvertUtils_1 = require("../Tools/TradingBotResConvertUtils");
const TradeAPIImpl_1 = require("../TradeAPI/TradeAPIImpl");
const BaseWebSocket_1 = require("../websocket/BaseWebSocket");
const AssetAPIImpl_1 = __importDefault(require("./asset/AssetAPIImpl"));
const BaseTradingApi_1 = __importDefault(require("./BaseTradingApi"));
class BaseBotApiAdapter extends BaseTradingApi_1.default {
    constructor(apiKey) {
        super(apiKey);
        this.checkServerTime = false;
        this.recvTimestamp = 0;
        this.refreshRightNow = new rxjs_1.Subject();
        this.baseExchangeAdapterImpl = null;
        if (apiKey) {
            if (!TradeUtils_1.TradeUtils.checkApiAccessWithBU(apiKey) && this.tradeExchangeInfo.localLogic) {
                this.baseExchangeAdapterImpl = (0, TradeAPIImpl_1.createExchangeApiAdapterWithKey)(apiKey, true);
            }
        }
        if ((0, Macro_1.isPionex)(apiKey.market)) {
            this.assetAPIImpl = new AssetAPIImpl_1.default(this.apiKey);
        }
    }
    _getCloudKeyIdObservable() {
        if (this.apiKey.source === "web") {
            return (0, rxjs_1.of)(this.apiKey.cloudKeyId);
        }
        return (0, trade_utils_lib_1.getTradeDependencyInstance)().getApiKeyCloudId(this.apiKey.key);
    }
    cancelCustomOrder(order) {
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.cancelCustomOrder(order);
        }
        let body = {
            exchange: this.apiKey.market,
            base: order.base,
            quote: order.quote,
            order_id: order.id,
            side: order.exchangeCustomOrder.side,
            symbol: `${order.base}/${order.quote}`,
        };
        ///> TODO v1 api
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(this.apiKey.market)) {
            let url;
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/order/${order.id}/?symbol=${order.base}/${order.quote}`;
            return this.keyResolver.requestSigner.getSignRequestV2("DELETE", url, undefined).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return order.id;
                }
                throw JSON.stringify(result);
            }));
        }
        else {
            return this.keyResolver.requestSigner.getSignRequest("POST", "/trades/cancel_order", JSON.stringify(body)).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return order.id;
                }
                throw JSON.stringify(result);
            }));
        }
    }
    createMarketOrder(order) {
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.createMarketOrder(order);
        }
        return this._createMarketOrderWithCloudObservable(order);
    }
    createCustomOrder(order) {
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.createCustomOrder(order);
        }
        return this._createCustomOrderWithCloudObservable(order);
    }
    _createMarketOrderWithCloudObservable(order) {
        let body = {
            exchange: this.apiKey.market,
            base: order.marketParam.base,
            quote: order.marketParam.quote,
            type: order.marketParam.type,
            side: order.marketParam.side,
            amount: order.marketParam.amount || null,
            spending: order.marketParam.spending || null,
            symbol: `${order.marketParam.base}/${order.marketParam.quote}`,
        };
        return this._createOrderWithCloudObservable(JSON.stringify(body), order.marketParam.type);
    }
    _createCustomOrderWithCloudObservable(order) {
        let body = {
            exchange: this.apiKey.market,
            base: order.customParam.base,
            quote: order.customParam.quote,
            note: order.note || null,
            side: order.customParam.side,
            price: `${order.customParam.price}`,
            amount: `${order.customParam.amount}`,
            type: order.customParam.type,
            symbol: `${order.customParam.base}/${order.customParam.quote}`,
        };
        return this._createOrderWithCloudObservable(JSON.stringify(body), order.customParam.type);
    }
    _createOrderWithCloudObservable(body, orderType) {
        ///> TODO v1 api
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(this.apiKey.market)) {
            let url;
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/order/`;
            return this.keyResolver.requestSigner.getSignRequestV2("POST", url, body).pipe((0, operators_1.mergeMap)((res) => {
                if (res.code === 0) {
                    let resp = {
                        status: 0,
                        orderType: orderType,
                        orderId: res.data.id,
                        orderData: res.data,
                    };
                    return (0, rxjs_1.of)(resp);
                }
                throw JSON.stringify(res);
            }));
        }
        else {
            return this.keyResolver.requestSigner.getSignRequest("POST", "/trades/create_order", body).pipe((0, operators_1.mergeMap)((res) => {
                if (res.code === 0) {
                    if (typeof res.data === "string") {
                        let resp = {
                            status: 0,
                            orderId: res.data,
                            orderType: orderType,
                            orderData: res.data,
                        };
                        return (0, rxjs_1.of)(resp);
                    }
                    else {
                        let resp = {
                            status: 0,
                            orderId: res.data.id,
                            orderType: orderType,
                            orderData: res.data,
                        };
                        return (0, rxjs_1.of)(resp);
                    }
                }
                throw JSON.stringify(res);
            }));
        }
    }
    fetchCloseOrders(base, quote, orderId, limit, direct, isManual, includeStrategy) {
        if ((!base || !quote) && !(0, Macro_1.isPionex)(this.apiKey.market)) {
            throw Error("cannot support query without symbol!");
        }
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.queryCustomClosedOrdersRestApi(base, quote);
        }
        let body = {
            exchange: this.apiKey.market,
        };
        if (base) {
            body["base"] = base;
        }
        if (quote) {
            body["quote"] = quote;
        }
        if (orderId) {
            body["orderId"] = orderId;
        }
        if (limit) {
            body["limit"] = limit;
        }
        if (isManual) {
            body["is_manual"] = isManual;
        }
        if (direct) {
            body["direct"] = direct;
        }
        if (base && quote) {
            body["symbol"] = `${base}/${quote}`;
        }
        let requestObservable;
        ///> TODO V1新接口
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(this.apiKey.market)) {
            let queryUrl;
            queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/closed_orders/`;
            let appendParam = false;
            if (base && quote) {
                appendParam = true;
                queryUrl = queryUrl.concat(`?symbol=${base}/${quote}`);
            }
            if (limit) {
                if (appendParam) {
                    queryUrl = queryUrl.concat(`&limit=${limit}`);
                }
                else {
                    queryUrl = queryUrl.concat(`?limit=${limit}`);
                }
                appendParam = true;
            }
            if (orderId) {
                if (appendParam) {
                    queryUrl = queryUrl.concat(`&from_id=${orderId}`);
                }
                else {
                    queryUrl = queryUrl.concat(`?from_id=${orderId}`);
                }
                queryUrl = queryUrl.concat(`&direct=${direct ? direct.toLowerCase() : "next"}`);
                appendParam = true;
            }
            if (includeStrategy !== undefined) {
                if (appendParam) {
                    queryUrl = queryUrl.concat(`&include_strategy=${includeStrategy}`);
                }
                else {
                    queryUrl = queryUrl.concat(`?include_strategy=${includeStrategy}`);
                }
                appendParam = true;
            }
            requestObservable = this.keyResolver.requestSigner.getSignRequestV2("GET", encodeURI(queryUrl), undefined);
        }
        else {
            requestObservable = this.keyResolver.requestSigner.getSignRequest("POST", "/trades/fetch_closed_orders", JSON.stringify(body));
        }
        return requestObservable
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                if (!result.data) {
                    return [];
                }
                return result.data.map((item) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const order = {
                        id: item.id,
                        datetime: item.datetime,
                        timestamp: item.timestamp,
                        lastTradeTimestamp: item.last_trade_timestamp,
                        status: item.status,
                        symbol: item.symbol,
                        type: item.type,
                        side: item.side,
                        average: item.average == null ? undefined : Number((_a = item.average) !== null && _a !== void 0 ? _a : 0),
                        price: Number((_b = item.price) !== null && _b !== void 0 ? _b : 0),
                        amount: Number((_c = item.amount) !== null && _c !== void 0 ? _c : 0),
                        filled: Number((_d = item.filled) !== null && _d !== void 0 ? _d : 0),
                        remaining: Number((_e = item.remaining) !== null && _e !== void 0 ? _e : 0),
                        cost: Number((_f = item.cost) !== null && _f !== void 0 ? _f : 0),
                        trades: item.trades,
                        fee: item.fee
                            ? {
                                type: item.fee.type,
                                currency: item.fee.currency,
                                rate: Number((_g = item.fee.rate) !== null && _g !== void 0 ? _g : 0),
                                cost: Number((_h = item.fee.cost) !== null && _h !== void 0 ? _h : 0),
                            }
                            : null,
                        info: item.info,
                    };
                    return order;
                });
            }
            throw JSON.stringify(result);
        }))
            .pipe((0, operators_1.catchError)(() => {
            return (0, rxjs_1.of)([]);
        }));
    }
    getSpotOrder(symbol, id) {
        if (!(0, Macro_1.isPionex)(this.apiKey.market)) {
            throw Error("not implement");
        }
        if (!symbol || !id) {
            throw "params is null";
        }
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/order/${id}/?symbol=${symbol}`;
        return this.keyResolver.requestSigner.getSignRequestV2("GET", encodeURI(url), undefined).pipe((0, operators_1.map)((res) => {
            if (res.code === 0 && res.data) {
                return TradeUtils_1.TradeUtils.convertToExchangeOrder(res.data);
            }
            throw res;
        }));
    }
    getExchangeSymbolsObservable() {
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.getExchangeSymbolsObservable();
        }
        let body = {
            exchange: this.apiKey.market,
        };
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(this.apiKey.market)) {
            let queryUrl;
            const productType = (0, trade_utils_lib_1.getTradeDependencyInstance)().getProductType();
            // @ts-ignore
            if (["pionex_us", trade_utils_lib_1.PRODUCT_TYPE.PIONEX_US, trade_utils_lib_1.PRODUCT_TYPE.PIONEX_US_V2].includes(productType)) {
                const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/spot_markets_us/`;
                // 优先尝试登录请求
                return trade_utils_lib_1.ObservableUtils.getV2(url, undefined, undefined, true).pipe((0, operators_1.catchError)(() => {
                    // 若未获取到token信息导致报错，则使用不附带Token的请求继续
                    return trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, false);
                }));
            }
            else {
                queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/spot_markets/`;
            }
            return trade_utils_lib_1.ObservableUtils.get(queryUrl, undefined, undefined, false);
        }
        else {
            let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_RPC_HOST}/trades/fetch_markets`, this.extraParamRuntime["commonParam"]);
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, undefined, JSON.stringify(body), (resp) => {
                return resp;
            }).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return result.data;
                }
                throw JSON.stringify(result);
            }));
        }
    }
    fetchOpenOrders(base, quote, orderId, limit, isManual, includeStrategy, strategyId) {
        if ((!base || !quote) && !(0, Macro_1.isPionex)(this.apiKey.market)) {
            throw Error("cannot support query without symbol!");
        }
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.queryCustomOpenOrdersRestApi(base, quote);
        }
        let body = {
            exchange: this.apiKey.market,
        };
        if (base) {
            body["base"] = base;
        }
        if (quote) {
            body["quote"] = quote;
        }
        if (orderId) {
            body["orderId"] = orderId;
        }
        if (limit) {
            body["limit"] = limit;
        }
        if (isManual) {
            body["is_manual"] = isManual;
        }
        if (base && quote) {
            body["symbol"] = `${base}/${quote}`;
        }
        if (strategyId) {
            body["strategy_id"] = strategyId;
        }
        let requestObservable;
        ///> TODO v1 api
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(this.apiKey.market)) {
            let queryUrl;
            queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/open_orders/`;
            let appendParam = false;
            if (base && quote) {
                queryUrl = queryUrl.concat(`?symbol=${base}/${quote}`);
                appendParam = true;
            }
            if ((0, Macro_1.isPionex)(this.apiKey.market)) {
                if (limit) {
                    if (appendParam) {
                        queryUrl = queryUrl.concat(`&limit=${limit}`);
                    }
                    else {
                        queryUrl = queryUrl.concat(`?limit=${limit}`);
                    }
                    appendParam = true;
                }
                if (orderId) {
                    if (appendParam) {
                        queryUrl = queryUrl.concat(`&from_id=${orderId}`);
                    }
                    else {
                        queryUrl = queryUrl.concat(`?from_id=${orderId}`);
                    }
                    appendParam = true;
                    if (appendParam) {
                        queryUrl = queryUrl.concat("&direct=prev");
                    }
                    else {
                        queryUrl = queryUrl.concat("?direct=prev");
                    }
                    appendParam = true;
                }
                if (includeStrategy !== undefined) {
                    if (appendParam) {
                        queryUrl = queryUrl.concat(`&include_strategy=${includeStrategy}`);
                    }
                    else {
                        queryUrl = queryUrl.concat(`?include_strategy=${includeStrategy}`);
                    }
                    appendParam = true;
                }
                if (strategyId !== undefined) {
                    if (appendParam) {
                        queryUrl = queryUrl.concat(`&strategy_id=${strategyId}`);
                    }
                    else {
                        queryUrl = queryUrl.concat(`?strategy_id=${strategyId}`);
                    }
                    appendParam = true;
                }
            }
            requestObservable = this.keyResolver.requestSigner.getSignRequestV2("GET", encodeURI(queryUrl), undefined);
        }
        else {
            requestObservable = this.keyResolver.requestSigner.getSignRequest("POST", "/trades/fetch_open_orders", JSON.stringify(body));
        }
        return requestObservable
            .pipe((0, operators_1.map)((result) => {
            var _a;
            if (result.code === 0) {
                return (_a = result.data) !== null && _a !== void 0 ? _a : [];
            }
            throw JSON.stringify(result);
        }))
            .pipe((0, operators_1.catchError)(() => {
            return (0, rxjs_1.of)([]);
        }));
    }
    /**
     * 根据网格订单号查询网格订单详情
     * @param gridOrderId
     * @param orderType
     */
    queryGridOrderBasicByIdWithRestApi(gridOrderId, orderType) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${gridOrderId}/`;
        const support = [
            TradeTypeDef_1.ExchangeOrderType.gridV5,
            TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
            TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
            TradeTypeDef_1.ExchangeOrderType.futures_smart_trade,
            TradeTypeDef_1.ExchangeOrderType.copy_bot,
            TradeTypeDef_1.ExchangeOrderType.futures_martingale,
        ];
        if (support.includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${gridOrderId}/`;
        }
        let data = { url, authType: trade_utils_lib_1.AuthType.Access };
        if (orderType === TradeTypeDef_1.ExchangeOrderType.futures_smart_trade) {
            data = { url, authType: trade_utils_lib_1.AuthType.FullToken };
        }
        return trade_utils_lib_1.Network.get(data).pipe((0, operators_1.map)((result) => {
            switch (orderType) {
                case undefined:
                case TradeTypeDef_1.ExchangeOrderType.grid:
                case TradeTypeDef_1.ExchangeOrderType.ig:
                case TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid:
                    return {
                        gridOrder: TradeUtils_1.TradeUtils.convertToExchangeOrder(result),
                        openOrdersCount: result.bu_order_data.exchange_order_count - result.bu_order_data.closed_exchange_order_count,
                        closeOrdersCount: result.bu_order_data.closed_exchange_order_count,
                    };
                case TradeTypeDef_1.ExchangeOrderType.futures_smart_trade:
                    return {
                        gridOrder: TradeUtils_1.TradeUtils.convertToExchangeOrder(result),
                        openOrdersCount: 0,
                        closeOrdersCount: 0,
                    };
                case TradeTypeDef_1.ExchangeOrderType.copy_bot:
                    return {
                        gridOrder: TradeUtils_1.TradeUtils.convertToExchangeOrder(result),
                        openOrdersCount: 0,
                        closeOrdersCount: 0,
                    };
                default:
                    return {
                        gridOrder: TradeUtils_1.TradeUtils.convertToExchangeOrder(result),
                        openOrdersCount: result.exchange_open_orders_count,
                        closeOrdersCount: result.placed_exchange_order_count - result.exchange_open_orders_count,
                    };
            }
        }));
    }
    /**
     * @
     * 网格订单头部详情刷新
     * @param griOrderId
     * @param orderType
     */
    getQueryGridBasicInfoObservable(griOrderId, orderType) {
        return (0, rxjs_1.timer)(0, 5000)
            .pipe((0, operators_1.takeWhile)(() => !this.stopRefreshGridDetail))
            .pipe((0, operators_1.switchMap)(() => {
            return this.queryGridOrderBasicByIdWithRestApi(griOrderId, orderType);
        }));
    }
    _queryGridOrderClosedOrdersWithRestApi(gridOrderId, limit, orderType) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)([]);
            }
            let url = "";
            if (orderType !== undefined && orderType !== TradeTypeDef_1.ExchangeOrderType.grid && orderType !== TradeTypeDef_1.ExchangeOrderType.ig) {
                url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${orderType}/${gridOrderId}/exchange_closed_orders_new?limit=${limit}`, this.extraParamRuntime["commonParam"]);
            }
            else {
                url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${gridOrderId}/exchange_closed_orders?limit=${limit}`, this.extraParamRuntime["commonParam"]);
            }
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, { Authorization: token.toString() }, (response) => {
                let value = response.data;
                return value.map((item) => {
                    let baseDisplay = "";
                    let isLeverage = false;
                    // isLeverage: findSymbol ? findSymbol.isLeverage : false,
                    if ("sell" in item && item.sell) {
                        const symbolInfo = this.symbolMap.get(`${item.sell.base}_${item.sell.quote}`);
                        baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.sell.base;
                        isLeverage = symbolInfo ? symbolInfo.isLeverage : false;
                    }
                    if ("buy" in item && item.buy) {
                        const symbolInfo = this.symbolMap.get(`${item.buy.base}_${item.buy.quote}`);
                        baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.buy.base;
                        isLeverage = symbolInfo ? symbolInfo.isLeverage : false;
                    }
                    let result = {
                        sellOrder: "sell" in item && item.sell
                            ? {
                                id: item.sell.exchange_order_id,
                                orderType: item.sell.type,
                                base: item.sell.base,
                                quote: item.sell.quote,
                                baseDisplay: baseDisplay,
                                isLeverage: isLeverage,
                                symbol: item.sell.symbol,
                                timestamp: item.sell.timestamp,
                                lastTradeTime: item.sell.lastTradeTimestamp,
                                tag: item.sell.tag,
                                state: "submitted",
                                isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.sell.status, (item.sell.filled ? item.sell.filled : 0) > 0)),
                                originOrderData: item,
                                exchangeCustomOrder: {
                                    side: item.sell.side,
                                    type: item.sell.type,
                                    price: item.sell.price,
                                    amount: item.sell.amount,
                                    filled_amount: item.sell.filled ? item.sell.filled : 0,
                                    filled_value: item.sell.cost ? item.sell.cost : 0,
                                    avgDealPrice: item.sell.cost
                                        ? new decimal_js_1.Decimal(item.sell.cost).div(item.sell.filled).toNumber()
                                        : 0,
                                    feeInQuote: item.sell.fee_in_quote ? Number(item.sell.fee_in_quote) : 0,
                                    fee: item.sell.fee,
                                    feeCoin: item.sell.fee_coin ? item.sell.fee_coin.toUpperCase() : "",
                                    feeRefund: item.sell.fee_income_cost,
                                    feeRefundCoin: item.sell.fee_income_coin ? item.sell.fee_income_coin.toUpperCase() : "",
                                    source: "",
                                },
                            }
                            : undefined,
                        buyOrder: "buy" in item && item.buy
                            ? {
                                id: item.buy.exchange_order_id,
                                orderType: item.buy.type,
                                base: item.buy.base,
                                quote: item.buy.quote,
                                baseDisplay: baseDisplay,
                                isLeverage: isLeverage,
                                symbol: item.buy.symbol,
                                timestamp: item.buy.timestamp,
                                lastTradeTime: item.buy.lastTradeTimestamp,
                                tag: item.buy.tag,
                                state: "submitted",
                                isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.buy.status, (item.buy.filled ? item.buy.filled : 0) > 0)),
                                originOrderData: item,
                                exchangeCustomOrder: {
                                    tag: item.buy.tag,
                                    side: item.buy.side,
                                    type: item.buy.type,
                                    price: item.buy.price,
                                    amount: item.buy.amount,
                                    filled_amount: item.buy.filled ? item.buy.filled : 0,
                                    filled_value: item.buy.cost ? item.buy.cost : 0,
                                    avgDealPrice: item.buy.cost
                                        ? new decimal_js_1.Decimal(item.buy.cost).div(item.buy.filled).toNumber()
                                        : 0,
                                    fee: item.buy.fee,
                                    feeInQuote: item.buy.fee_in_quote ? Number(item.buy.fee_in_quote) : 0,
                                    feeCoin: item.buy.fee_coin ? item.buy.fee_coin.toUpperCase() : "",
                                    feeRefund: item.buy.fee_income_cost,
                                    feeRefundCoin: item.buy.fee_income_coin ? item.buy.fee_income_coin.toUpperCase() : 0,
                                    source: "",
                                },
                            }
                            : undefined,
                    };
                    return {
                        tag: result.buyOrder ? result.buyOrder.tag : result.sellOrder.tag,
                        sellOrder: result.sellOrder,
                        buyOrder: result.buyOrder,
                    };
                });
            });
        }));
    }
    /**
     * 网格订单close状态刷新
     * @param gridOrderId
     * @param limit
     * @param orderType
     */
    getQueryGridCloseOrdersObservable(gridOrderId, limit, orderType) {
        return (0, rxjs_1.of)(0)
            .pipe((0, operators_1.mergeMap)(() => {
            return (0, rxjs_1.interval)(5000);
        }))
            .pipe((0, operators_1.takeWhile)(() => !this.stopRefreshGridDetail))
            .pipe((0, operators_1.startWith)(0))
            .pipe((0, operators_1.switchMap)(() => {
            return this._queryGridOrderClosedOrdersWithRestApi(gridOrderId, limit, orderType);
        }));
    }
    getQueryGridCloseOrdersOnce(gridOrderId, limit, orderType) {
        return this._queryGridOrderClosedOrdersWithRestApi(gridOrderId, limit, orderType);
    }
    queryGridPairedCloseOrderList(orderId, orderType, pageToken, trend) {
        let url = "";
        const urlParams = {};
        if (pageToken) {
            urlParams["page_token"] = pageToken;
        }
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid ||
            orderType === TradeTypeDef_1.ExchangeOrderType.gridV5 ||
            orderType === TradeTypeDef_1.ExchangeOrderType.gridV4 ||
            orderType === TradeTypeDef_1.ExchangeOrderType.gridV4Futures) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/paired_exchange_orders/`;
            if (trend) {
                urlParams["trend"] = trend;
            }
        }
        else {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/paired_exchange_orders/`;
        }
        return trade_utils_lib_1.Network.get({ url, data: urlParams, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((value) => {
            const result = value;
            const orderList = result.results.map((item) => {
                var _a, _b;
                let baseDisplay = "";
                let isLeverage = false;
                // isLeverage: findSymbol ? findSymbol.isLeverage : false,
                if ("sell" in item && item.sell) {
                    const symbolInfo = this.symbolMap.get(`${item.sell.base}_${item.sell.quote}`);
                    baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.sell.base;
                    isLeverage = symbolInfo ? symbolInfo.isLeverage : false;
                }
                if ("buy" in item && item.buy) {
                    const symbolInfo = this.symbolMap.get(`${item.buy.base}_${item.buy.quote}`);
                    baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.buy.base;
                    isLeverage = symbolInfo ? symbolInfo.isLeverage : false;
                }
                let result = {
                    sellOrder: "sell" in item && item.sell
                        ? {
                            id: item.sell.exchange_order_id,
                            orderType: item.sell.type,
                            base: item.sell.base,
                            quote: item.sell.quote,
                            baseDisplay: baseDisplay,
                            isLeverage: isLeverage,
                            symbol: item.sell.symbol,
                            timestamp: item.sell.timestamp,
                            lastTradeTime: (_a = item.sell.lastTradeTimestamp) !== null && _a !== void 0 ? _a : item.sell.last_trade_timestamp,
                            tag: item.sell.tag,
                            state: "submitted",
                            isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.sell.status, (item.sell.filled ? item.sell.filled : 0) > 0)),
                            originOrderData: item,
                            exchangeCustomOrder: {
                                side: item.sell.side,
                                type: item.sell.type,
                                price: item.sell.price,
                                amount: item.sell.amount,
                                average: item.sell.average,
                                filled_amount: item.sell.filled ? item.sell.filled : 0,
                                filled_value: item.sell.cost ? item.sell.cost : 0,
                                avgDealPrice: item.sell.cost ? new decimal_js_1.Decimal(item.sell.cost).div(item.sell.filled).toNumber() : 0,
                                feeInQuote: item.sell.fee_in_quote ? Number(item.sell.fee_in_quote) : 0,
                                fee: item.sell.fee,
                                feeCoin: item.sell.fee_coin ? item.sell.fee_coin.toUpperCase() : "",
                                feeRefund: item.sell.fee_income_cost,
                                feeRefundCoin: item.sell.fee_income_coin ? item.sell.fee_income_coin.toUpperCase() : "",
                                source: "",
                            },
                        }
                        : undefined,
                    buyOrder: "buy" in item && item.buy
                        ? {
                            id: item.buy.exchange_order_id,
                            orderType: item.buy.type,
                            base: item.buy.base,
                            quote: item.buy.quote,
                            baseDisplay: baseDisplay,
                            isLeverage: isLeverage,
                            symbol: item.buy.symbol,
                            timestamp: item.buy.timestamp,
                            lastTradeTime: (_b = item.buy.lastTradeTimestamp) !== null && _b !== void 0 ? _b : item.buy.last_trade_timestamp,
                            tag: item.buy.tag,
                            state: "submitted",
                            isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.buy.status, (item.buy.filled ? item.buy.filled : 0) > 0)),
                            originOrderData: item,
                            exchangeCustomOrder: {
                                tag: item.buy.tag,
                                side: item.buy.side,
                                type: item.buy.type,
                                price: item.buy.price,
                                amount: item.buy.amount,
                                average: item.buy.average,
                                filled_amount: item.buy.filled ? item.buy.filled : 0,
                                filled_value: item.buy.cost ? item.buy.cost : 0,
                                avgDealPrice: item.buy.cost ? new decimal_js_1.Decimal(item.buy.cost).div(item.buy.filled).toNumber() : 0,
                                fee: item.buy.fee,
                                feeInQuote: item.buy.fee_in_quote ? Number(item.buy.fee_in_quote) : 0,
                                feeCoin: item.buy.fee_coin ? item.buy.fee_coin.toUpperCase() : "",
                                feeRefund: item.buy.fee_income_cost,
                                feeRefundCoin: item.buy.fee_income_coin ? item.buy.fee_income_coin.toUpperCase() : 0,
                                source: "",
                            },
                        }
                        : undefined,
                };
                return {
                    tag: result.buyOrder ? result.buyOrder.tag : result.sellOrder.tag,
                    sellOrder: result.sellOrder,
                    buyOrder: result.buyOrder,
                };
            });
            return {
                nextPageToken: "next_page_token" in result ? result["next_page_token"] : undefined,
                pairedOrderList: orderList,
            };
        }));
    }
    queryGridPairedCloseOrderListV2(params) {
        let url = "";
        const urlParams = {};
        if (params.pageToken) {
            urlParams["page_token"] = params.pageToken;
        }
        if (params.limit) {
            urlParams["limit"] = params.limit;
        }
        if (params.only_paired) {
            urlParams["only_paired"] = params.only_paired;
        }
        const supportTradingBotApiHost = [
            TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
            TradeTypeDef_1.ExchangeOrderType.gridV5,
            TradeTypeDef_1.ExchangeOrderType.gridV4,
            TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
        ];
        if (supportTradingBotApiHost.includes(params.orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/paired_exchange_orders/`;
            if (params.trend) {
                urlParams["trend"] = params.trend;
            }
        }
        else {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${params.orderType}/${params.orderId}/paired_exchange_orders/`;
        }
        return trade_utils_lib_1.Network.get({ url, data: urlParams, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((value) => {
            return TradingBotResConvertUtils_1.TradingBotResConvertUtils.queryGridPairedCloseOrderListV2Handle(value, supportTradingBotApiHost, params.orderType);
        }));
    }
    /**
     * 网格订单详情刷新
     * @param base
     * @param quote
     * @param griOrderId
     *    @deprecated
     */
    getQueryGridDescObservable(base, quote, griOrderId) {
        return (0, rxjs_1.of)(undefined);
    }
    _queryGridOrderOpenOrdersWithRestApi(gridOrderId, orderType, trend) {
        let url = "";
        const urlParams = {};
        if ([
            TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
            TradeTypeDef_1.ExchangeOrderType.gridV5,
            TradeTypeDef_1.ExchangeOrderType.gridV4,
            TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
        ].includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${gridOrderId}/open_exchange_orders/`;
            if (trend) {
                urlParams["trend"] = trend;
            }
        }
        else {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${gridOrderId}/open_exchange_orders/`;
        }
        return trade_utils_lib_1.Network.get({ url, data: urlParams, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((res) => {
            const value = res || [];
            return value.map((item) => {
                const symbolInfo = this.symbolMap.get(`${item.base}_${item.quote}`);
                return {
                    id: item.exchange_order_id,
                    orderType: item.type,
                    base: item.base,
                    quote: item.quote,
                    symbol: item.symbol,
                    timestamp: item.timestamp,
                    lastTradeTimestamp: item.last_trade_timestamp,
                    tag: item.tag,
                    state: "submitted",
                    baseDisplay: symbolInfo ? symbolInfo.baseDisplay : item.base,
                    isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                    isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(item.status, (item.filled ? item.filled : 0) > 0)),
                    originOrderData: item,
                    exchangeCustomOrder: {
                        side: item.side,
                        type: item.type,
                        price: item.price,
                        amount: item.amount,
                        filled_amount: item.filled ? item.filled : 0,
                        filled_value: item.cost ? item.cost : 0,
                        fee: 0,
                        feeCoin: "",
                        source: "",
                    },
                };
            });
        }));
    }
    /**
     * 网格订单open状态刷新
     * @param gridOrderId
     * @param orderType
     */
    getQueryGridOpenOrdersObservable(gridOrderId, orderType, trend) {
        return (0, rxjs_1.timer)(0, 5000)
            .pipe((0, operators_1.takeWhile)(() => !this.stopRefreshGridDetail))
            .pipe((0, operators_1.switchMap)(() => {
            return this._queryGridOrderOpenOrdersWithRestApi(gridOrderId, orderType, trend);
        }));
    }
    /**
     * 查询BU策略订单websocket接口
     * @param {string} base
     * @param {string} quote
     * @returns {Observable<ExchangeOrder>}
     */
    _listenBotTradeStatusChange(base, quote) {
        return this._listenBotTradeStatusChangeValue(base, quote).pipe((0, operators_1.map)(() => true));
    }
    /**
     * 查询BU策略订单websocket接口 v1.4接口版本后使用，修改返回参数
     * @param {string} base
     * @param {string} quote
     * @returns {Observable<ExchangeOrder>}
     */
    _listenBotTradeStatusChangeValue(base, quote, exchange) {
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            return (0, trade_utils_lib_1.getTradeDependencyInstance)()
                .getAccessToken()
                .pipe((0, operators_1.mergeMap)((token) => {
                if (!token || !this.shouldCheckStrategyOrder()) {
                    return rxjs_1.NEVER;
                }
                let url = `${this.extraParamRuntime["TRADE_ORDERS"]}/orders?tk=${token}`;
                if (exchange !== undefined) {
                    url += `&exchange=${exchange}`;
                }
                const wsConfig = {
                    url: url,
                    deserializer: (value) => {
                        try {
                            let tempData = JSON.parse(value.data);
                            return tempData;
                        }
                        catch (e) {
                            return undefined;
                        }
                    },
                    openObserver: {
                        next: (event) => {
                            if (!event.target) {
                                return;
                            }
                        },
                    },
                    closeObserver: {
                        next: (event) => { },
                    },
                };
                return (0, webSocket_1.webSocket)(wsConfig);
            }));
        });
    }
    /**
     * 根据网格订单状态查询网格订单详情
     * param status
     * @private
     */
    _queryBotOrderByStatusWithRestApi(pgno = 0, pgnm = 20, status, base, quote) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)([]);
            }
            let url = `${this.extraParamRuntime["TRADE_HOST"]}/order/basic_infos?exchange=${this.apiKey.market}&pgno=${pgno}&pgnm=${pgnm}&status=${status}`;
            if (base && quote) {
                url += `&base=${base}&quote=${quote}`;
            }
            if (this.apiKey.cloudKeyId) {
                url += `&key_id=${this.apiKey.cloudKeyId}`;
            }
            url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]);
            let headers = {
                Authorization: token,
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (resp) => {
                return this.botOrdersSourceDataHandle(resp.data);
            });
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)([]);
        }));
    }
    /**
     * 根据网格订单状态查询网格订单详情(修改传参)
     * param status
     * @private
     */
    _queryBotOrderByStatusWithRestApiV2(param, allExchange) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.switchMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)([]);
            }
            let url = `${this.extraParamRuntime["TRADE_HOST"]}/order/basic_infos?pgno=${param.pageNo}&pgnm=${param.pageNum}&status=${param.status}`;
            if (!allExchange) {
                url += `&exchange=${this.apiKey.market}`;
            }
            if (param.base && param.quote) {
                url += `&base=${param.base}&quote=${param.quote}`;
            }
            if (param.orderType) {
                url += `&bu_order_type=${param.orderType}`;
            }
            if (this.apiKey.cloudKeyId) {
                url += `&key_id=${this.apiKey.cloudKeyId}`;
            }
            url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]);
            let headers = {
                Authorization: token,
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (resp) => {
                return this.botOrdersSourceDataHandle(resp.data);
            });
        }));
    }
    /**
     * 根据网格订单状态查询网格订单数量
     * params status
     * @private
     */
    _queryBotOrderCountByStatusWithRestApi(params) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)(0);
            }
            let url = `${this.extraParamRuntime["TRADE_HOST"]}/order/order_count?exchange=${this.apiKey.market}&status=${params.status}`;
            if (params.base && params.quote) {
                url += `&base=${params.base}&quote=${params.quote}`;
            }
            if (params.orderType) {
                url += `&bu_order_type=${params.orderType}`;
            }
            if (this.apiKey.cloudKeyId) {
                url += `&key_id=${this.apiKey.cloudKeyId}`;
            }
            url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]);
            let headers = {
                Authorization: token,
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (resp) => {
                return resp.data.total;
            });
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(0);
        }));
    }
    /**
     * 服务器item数据处理为客户端需要的数据结构
     * @param data
     */
    botOrdersSourceDataHandle(data) {
        return data
            .map((item) => {
            return TradeUtils_1.TradeUtils.convertToExchangeOrder(item);
        })
            .filter((item) => {
            return item !== undefined && item !== null;
        });
    }
    /**
     *  根据服务端返回的订单，顺便查询网格利润。
     * @param result
     * @private
     */
    _calcGridOrderProfitHandle(result) {
        ///> 20200817 更换了订阅ticker的方式，在此也不需要重复计算利润，计算利润的逻辑已经在工程中实现
        return (0, rxjs_1.of)(result);
    }
    /**
     * 查询websocket 接口更新的bot订单
     */
    getWebSocketMarketBotOrders(exchange) {
        return this._listenBotTradeStatusChangeValue(null, null, exchange)
            .pipe((0, operators_1.map)((result) => {
            if (result == undefined) {
                return [];
            }
            // if (result.exchange != this.apiKey.market) return [];
            ///> websocket通知在用rest api zip的形式请求两端数据合并
            return this.botOrdersSourceDataHandle([result]);
        }))
            .pipe((0, operators_1.concatMap)((result) => {
            if (result.length == 0) {
                return (0, rxjs_1.of)([]);
            }
            return this._calcGridOrderProfitHandle(result);
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)([]);
        }));
    }
    /**
     * 上拉加载更多 bot 订单
     */
    getQueryByStatusMarketBotOrdersMore(pageNo, pageNum, status, base, quote) {
        return this._queryBotOrderByStatusWithRestApi(pageNo, pageNum, status, base, quote).pipe((0, operators_1.switchMap)((result) => {
            if (result.length != 0) {
                return this._calcGridOrderProfitHandle(result);
            }
            else {
                return (0, rxjs_1.of)([]);
            }
        }));
    }
    /**
     * 传参对象化
     * 上拉加载更多 bot 订单
     */
    getQueryBotOrdersMoreV2(param) {
        return this._queryBotOrderByStatusWithRestApiV2(param).pipe((0, operators_1.switchMap)((result) => {
            if (result.length != 0) {
                return this._calcGridOrderProfitHandle(result);
            }
            else {
                return (0, rxjs_1.of)([]);
            }
        }));
    }
    /**
     * 获取所有交易所的bot订单
     * @param param
     * @param allExchange
     */
    getQueryAllMarketBotOrdersMoreV2(param, allExchange) {
        return this._queryBotOrderByStatusWithRestApiV2(param, allExchange).pipe((0, operators_1.switchMap)((result) => {
            if (result.length != 0) {
                return this._calcGridOrderProfitHandle(result);
            }
            else {
                return (0, rxjs_1.of)([]);
            }
        }));
    }
    // grid v4 和 hedge grid 获取历史收益曲线
    queryGridProBalanceSequence(orderType, orderId, period) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/history_chart/`;
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4 ||
            orderType === TradeTypeDef_1.ExchangeOrderType.gridV5 ||
            orderType === TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid ||
            orderType === TradeTypeDef_1.ExchangeOrderType.gridV4Futures ||
            orderType === TradeTypeDef_1.ExchangeOrderType.SR ||
            orderType === TradeTypeDef_1.ExchangeOrderType.martingale ||
            orderType === TradeTypeDef_1.ExchangeOrderType.futures_martingale) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/history_chart/`;
            if (period !== undefined) {
                url += `?period=${period}`;
            }
        }
        return trade_utils_lib_1.Network.get({ url, authType: trade_utils_lib_1.AuthType.Access })
            .pipe((0, operators_1.map)((resp) => {
            return TradingBotResConvertUtils_1.TradingBotResConvertUtils.queryGridProBalanceSequenceHandle(resp, orderType);
        }))
            .pipe((0, operators_1.catchError)((err) => {
            return (0, rxjs_1.of)(undefined);
        }));
    }
    /**
     * enhanceAip 收益
     * @param orderType
     * @param orderId
     */
    queryGridProBalanceSequenceV2(orderType, orderId) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/history_chart/`;
        return trade_utils_lib_1.ObservableUtils.get(url, {}, {}, true).pipe((0, operators_1.map)((res) => {
            return res === null || res === void 0 ? void 0 : res.map((v) => {
                return {
                    time_block: v.timestamp,
                    profit: v.staking_profit,
                    balance: v.total_balance,
                    transactions: 0,
                    investment: v.investment,
                    quote_price: v.quote_price,
                    extra_margin: v.extra_margin,
                };
            });
        }));
    }
    /**
     * 获取bot订单数量
     * @param params
     */
    getMarketBotOrdersCountByStatus(params) {
        return this._queryBotOrderCountByStatusWithRestApi(params).pipe((0, operators_1.switchMap)((result) => {
            return (0, rxjs_1.of)(result);
        }));
    }
    /**
     * 初始查询bot订单（v1.4以上版本使用）
     */
    getQueryByStatusMarketBotOrders() {
        let zipObservable = (0, rxjs_1.zip)(this._queryBotOrderByStatusWithRestApi(0, 20, "running"), this._queryBotOrderByStatusWithRestApi(0, 20, "finished"));
        return zipObservable
            .pipe((0, operators_1.map)((result) => {
            return result.reduce((a, b) => {
                return a.concat(b);
            });
        }))
            .pipe((0, operators_1.switchMap)((result) => {
            if (result.length != 0) {
                return this._calcGridOrderProfitHandle(result);
            }
            else {
                return (0, rxjs_1.of)([]);
            }
        }));
    }
    /**
     * 查询bot全部订单
     * @deprecated
     *
     */
    getQueryMarketAllBotOrders() {
        return (0, rxjs_1.of)([]);
    }
    getTickerImpl(base, quote) {
        throw `${this.apiKey.market} not support ticker`;
    }
    recoverGridOrder(orderId) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)(undefined);
            }
            ///> 止盈止损单
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/recover`;
            let body = {
                bu_order_id: orderId,
            };
            let headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), headers, body, (resp) => {
                return resp;
            })
                .pipe((0, operators_1.map)(() => {
                return true;
            }))
                .pipe((0, operators_1.catchError)(() => {
                return (0, rxjs_1.of)(false);
            }));
        }));
    }
    getDepthData(base, quote) {
        if (this.supportBUOrderBookWebSocket()) {
            return this.getOrderBookDataFromBUServerObservable(base, quote).pipe((0, operators_1.throttleTime)(1000));
        }
        throw `${this.apiKey.market} not depth webSocket`;
    }
    stopRefreshGridDetailInfo() {
        this.stopRefreshGridDetail = true;
    }
    /**
     * 取消bu策略订单
     * @param {string} orderId
     * @param orderType
     * @param info
     * @returns {Observable<string>}
     */
    cancelStrategyOrder(orderId, orderType, info) {
        // 网格2.0路径
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/cancel/`;
        if (orderType === TradeTypeDef_1.OrderTypeDesc.GRID ||
            orderType === TradeTypeDef_1.OrderTypeDesc.AIP ||
            orderType === TradeTypeDef_1.OrderTypeDesc.TWAP ||
            orderType === TradeTypeDef_1.OrderTypeDesc.TRAILING_STOP_LIMIT ||
            orderType === TradeTypeDef_1.OrderTypeDesc.STOP_LIMIT) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/cancel`;
        }
        else if ([
            TradeTypeDef_1.ExchangeOrderType.gridV5,
            TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
            TradeTypeDef_1.ExchangeOrderType.copy_bot,
            TradeTypeDef_1.ExchangeOrderType.futures_martingale,
        ].includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/cancel/`;
        }
        let body = {};
        if (info && typeof info === "object") {
            body = Object.assign({}, info);
        }
        if (orderType !== TradeTypeDef_1.ExchangeOrderType.gridV4Futures) {
            body["bu_order_id"] = orderId;
        }
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            if (body["close_sell_model"] === undefined) {
                if (body["convert_into_earn_coin"]) {
                    body["close_sell_model"] = TradeTypeDef_1.BotOrderCloseModel.TO_QUOTE;
                }
                else {
                    body["close_sell_model"] = TradeTypeDef_1.BotOrderCloseModel.NOT_SELL;
                }
            }
        }
        return trade_utils_lib_1.Network.post({
            url,
            data: body,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((res) => {
            return orderId;
        }));
    }
    /**
     * 取消订单的封装（常规订单 + 策略）
     * @param {ExchangeOrder} order
     * @param info
     * @returns {Observable<string>}
     */
    cancelOrder(order, info) {
        if (order.orderType === TradeTypeDef_1.OrderTypeDesc.MARKET || order.orderType === TradeTypeDef_1.OrderTypeDesc.LIMIT) {
            return this.cancelCustomOrder(order);
        }
        else {
            ///> 取消策略订单
            return this.cancelStrategyOrder(order.id, order.orderType, info);
        }
    }
    /**
     * 删除所有订单
     * @param order
     */
    cancelAllOrder(order) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)([]);
            }
            let url = `${this.extraParamRuntime["TRADE_HOST"]}/order/cancel_all`;
            let headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), headers, order, (resp) => {
                if (resp.code === 0) {
                    return resp.data;
                }
                return [];
            });
        }));
    }
    createOrder(order) {
        // 普通市价限价单, 单独处理
        const singleOrder$ = (0, rxjs_1.of)(0).pipe((0, operators_1.exhaustMap)(() => {
            if (order.filter !== undefined && !order.filter) {
                return (0, rxjs_1.of)(true);
            }
            else {
                return this.createFilterObservable(order);
            }
        }), (0, operators_1.switchMap)(() => {
            if (order.marketParam) {
                // 市价单
                return this.createMarketOrder(order);
            }
            else {
                // 限价单
                return this.createCustomOrder(order);
            }
        }));
        const botOrder$ = this._getCloudKeyIdObservable().pipe((0, operators_1.map)((key_id) => {
            if (!key_id) {
                throw "Key ID not found";
            }
            let orderType = order.orderType;
            let url = "";
            let body = {};
            if (order.stopLimitParam && order.stopLimitParam.customParam.type === TradeTypeDef_1.ExchangeOrderType.stopLimit) {
                ///> 止盈止损单
                orderType = order.stopLimitParam.customParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/create`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: order.stopLimitParam.customParam.base,
                    quote: order.stopLimitParam.customParam.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: order.stopLimitParam.customParam.type,
                    bu_order_data: {
                        amount: order.stopLimitParam.customParam.amount,
                        stop: order.stopLimitParam.stop,
                        limit: order.stopLimitParam.limit,
                        placed: order.stopLimitParam.customParam.price,
                        side: order.stopLimitParam.customParam.side,
                    },
                };
            }
            else if (order.STProParams && order.STProParams.type === TradeTypeDef_1.ExchangeOrderType.SL_Pro) {
                ///> 新止盈止损
                orderType = order.STProParams.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                const params = order.STProParams;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: params.base,
                    quote: params.quote,
                    bu_order_type: orderType,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_data: {
                        type: params.conditionType,
                        side: params.side,
                        condition: params.condition,
                        condition_direction: params.condition_direction,
                        price: params.price,
                        amount: params.amount || null,
                        quantity: params.quantity || null,
                    },
                };
            }
            else if (order.smartTradeParams && order.smartTradeParams.type === TradeTypeDef_1.ExchangeOrderType.smartTrade) {
                ///> smart trade
                orderType = order.smartTradeParams.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                const params = order.smartTradeParams;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: params.base,
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        smart_type: params.smart_type,
                        buy: params.buy,
                        trigger: params.trigger,
                        amount: params.amount,
                        trailing_percentage: params.trailing_percentage,
                        loss_stop: params.loss_stop,
                        trailing_buy_percent: params.trailing_buy_percent || null,
                        trigger_profit_percent: params.trigger_profit_percent || null,
                        stop_loss_percent: params.stop_loss_percent || null,
                    },
                };
            }
            else if (order.gridParam && order.gridParam.type === TradeTypeDef_1.ExchangeOrderType.grid) {
                // 网格1.0
                orderType = order.gridParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/create`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: order.gridParam.base,
                    quote: order.gridParam.quote,
                    note: order.note || null,
                    bu_order_type: TradeTypeDef_1.ExchangeOrderType.grid,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_data: {
                        top: order.gridParam.high,
                        bottom: order.gridParam.low,
                        row: order.gridParam.number,
                        per_volume: order.gridParam.amount,
                        loss_stop: order.gridParam.stop,
                    },
                };
                if (order.gridParam.feeRate) {
                    body["bu_order_data"]["user_defined_fee_rate"] = order.gridParam.feeRate;
                }
                if (order.gridParam.feeRateToExchange) {
                    body["bu_order_data"]["fee_set_to_exchange"] = order.gridParam.feeRateToExchange ? 1 : 0;
                }
                // 新手任务添加的固定值
                if (order.gridParam.userFirstOrder) {
                    body["tag_info"] = {
                        tag: "auto_stop",
                        source_info: "newbie_task",
                    };
                }
            }
            else if (order.gridProParam) {
                ///> 网格2.0 pro 和 V3 和网格类
                orderType = order.gridProParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${orderType}/create`;
                if ([TradeTypeDef_1.ExchangeOrderType.gridV3, TradeTypeDef_1.ExchangeOrderType.gridV4].includes(orderType)) {
                    url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                }
                if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(orderType)) {
                    url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/`;
                }
                const params = order.gridProParam;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: params.base,
                    quote: params.quote,
                    note: order.note || null,
                    ignore_state: order.ignore_state || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        top: params.top,
                        bottom: params.bottom,
                        row: params.row,
                        grid_type: params.grid_type,
                        earn_coin: params.earn_coin,
                        trend: params.trend,
                        base_total_investment: params.base_total_investment || "0",
                        quote_total_investment: params.quote_total_investment || "0",
                        open_position_buy_limit: params.open_position_buy_limit || null,
                        open_position_sell_limit: params.open_position_sell_limit || null,
                        loss_stop: params.loss_stop || null,
                        profit_stop: params.profit_stop || null,
                        condition: params.condition || null,
                        condition_direction: params.condition_direction || null,
                        leverage: params.leverage || null,
                        per_volume: params.per_volume || null,
                        open_price: params.open_price || null,
                        is_trial_fund: params.is_trial_fund,
                    },
                    strategy_id: params.trial_fund_id,
                };
                //短期只做v3适配
                if ([
                    TradeTypeDef_1.ExchangeOrderType.gridV3,
                    TradeTypeDef_1.ExchangeOrderType.gridV4,
                    TradeTypeDef_1.ExchangeOrderType.gridV5,
                    TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
                ].includes(orderType)) {
                    if (params.profit_stop_delay) {
                        if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(orderType)) {
                            body.bu_order_data.profit_stop_delay = Number(params.profit_stop_delay);
                        }
                        else {
                            body.bu_order_data.profit_stop_delay = params.profit_stop_delay;
                        }
                    }
                    else {
                        body.bu_order_data.profit_stop_delay = null;
                    }
                    if (params.loss_stop_delay) {
                        if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(orderType)) {
                            body.bu_order_data.loss_stop_delay = Number(params.loss_stop_delay);
                        }
                        else {
                            body.bu_order_data.loss_stop_delay = params.loss_stop_delay;
                        }
                    }
                    else {
                        body.bu_order_data.loss_stop_delay = null;
                    }
                    body.bu_order_data.close_sell_model_profit_stop = params.close_sell_model_profit_stop || null;
                    body.bu_order_data.close_sell_model_loss_stop = params.close_sell_model_loss_stop || null;
                    body.bu_order_data.moving_indicator_type = params.moving_indicator_type || null;
                    body.bu_order_data.moving_indicator_interval = params.moving_indicator_interval || null;
                    body.bu_order_data.moving_indicator_param = params.moving_indicator_param || null;
                    body.bu_order_data.moving_trailing_up_param = params.moving_trailing_up_param || null;
                    if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
                        body.bu_order_data.loss_stop_type = params.loss_stop_type || null;
                        body.bu_order_data.profit_stop_type = params.profit_stop_type || null;
                        body.bu_order_data.share_profit_type = params.share_profit_type || null;
                    }
                    if (params.slippage) {
                        body.bu_order_data.slippage = params.slippage;
                    }
                }
                // 适配v4future
                if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4Futures) {
                    body.bu_order_data.ui_extra_data = params.ui_extra_data || null;
                    body.group_id = params.group_id || null;
                    body.copy_bot_order_id = params.copy_bot_order_id || null;
                    body.bu_order_data.base_investment = params.base_total_investment || "0";
                    body.bu_order_data.quote_investment = params.quote_total_investment || "0";
                    body.bu_order_data.extra_margin = params.extra_margin || null;
                    body.bu_order_data.min_open_orders = 0;
                    body.bu_order_data.loss_stop_type = params.loss_stop_type || null;
                    body.bu_order_data.loss_stop_high = params.loss_stop_high || null;
                    body.bu_order_data.profit_stop_type = params.profit_stop_type || null;
                    body.bu_order_data.ui_invest_coin = params.ui_invest_coin || null;
                    body.bu_order_data.invest_coin = params.invest_coin || null;
                    body.bu_order_data.investment_from = params.investment_from || null;
                    body.bu_order_data.bonus_id = params.bonus_id || null;
                    body.bu_order_data.profit_stop_limit_price = params.profit_stop_limit_price || null;
                    body.bu_order_data.loss_stop_limit_price = params.loss_stop_limit_price || null;
                    body.bu_order_data.loss_stop_limit_high_price = params.loss_stop_limit_high_price || null;
                    if (body.bu_order_data.leverage) {
                        body.bu_order_data.leverage = new trade_utils_lib_1.SafeDecimal(body.bu_order_data.leverage).toNumber();
                    }
                }
                // 新手任务添加的固定值
                if (params.userFirstOrder) {
                    body["tag_info"] = {
                        tag: "auto_stop",
                        source_info: "newbie_task",
                    };
                }
                if (params.share_ratio) {
                    body.bu_order_data.share_ratio = params.ui_invest_coin;
                }
                if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4) {
                    body.bu_order_data.invest_coin = params.invest_coin;
                    body.bu_order_data.cate_type = params.cate_type;
                    body.bu_order_data.parameter_hidden = params.parameter_hidden;
                    body.bu_order_data.channel = params.channel;
                }
            }
            else if (order.smartRebalance && order.smartRebalance.type === TradeTypeDef_1.ExchangeOrderType.SR) {
                // 多币轮动
                const params = order.smartRebalance;
                orderType = params.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: "_",
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        portfolio: params.portfolio,
                        bu_order_sub_type: params.subType,
                        quote_total_investment: params.investment,
                        rebalance_enabled: params.rebalance_enabled,
                        rebalance_trigger_type: params.rebalance_trigger_type,
                        rebalance_param: params.rebalance_param,
                        loss_stop_percentage: params.loss_stop_percentage || null,
                        profit_stop_percentage: params.profit_stop_percentage || null,
                    },
                };
                if (params.index_id) {
                    body.bu_order_data["index_id"] = params.index_id;
                }
            }
            else if (order.martingale && order.martingale.type === TradeTypeDef_1.ExchangeOrderType.martingale) {
                // 马丁格尔
                const params = order.martingale;
                orderType = params.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: "_",
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        sub_order_type: params.sub_order_type,
                        portfolio: params.portfolio,
                        quote_total_investment: params.quote_total_investment,
                    },
                };
                if (params.stop_profit_percentage !== undefined) {
                    body.bu_order_data.stop_profit_percentage = params.stop_profit_percentage;
                }
                if (params.stop_loss_percentage !== undefined) {
                    body.bu_order_data.stop_loss_percentage = params.stop_loss_percentage;
                }
                if (params.unrealized_stop_loss_percentage !== undefined) {
                    body.bu_order_data.unrealized_stop_loss_percentage = params.unrealized_stop_loss_percentage;
                }
                if (params.is_multi) {
                    body.bu_order_data.is_multi = params.is_multi;
                    if (params.max_active_coins) {
                        body.bu_order_data.max_active_coins = params.max_active_coins;
                    }
                }
            }
            else if (order.futures_martingale && order.futures_martingale.type === TradeTypeDef_1.ExchangeOrderType.futures_martingale) {
                const params = order.futures_martingale;
                orderType = params.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: "_",
                    quote: params.quote,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        trend: params.trend,
                        leverage: params.leverage,
                        extra_margin: params.extra_margin,
                        quote_investment: params.quote_investment,
                        sub_order_type: params.sub_order_type,
                        portfolio: params.portfolio,
                    },
                };
                if (params.profit_stop) {
                    body.bu_order_data.profit_stop_type = params.profit_stop_type || null;
                    body.bu_order_data.profit_stop = params.profit_stop;
                }
                if (params.loss_stop) {
                    body.bu_order_data.loss_stop_type = params.loss_stop_type || null;
                    body.bu_order_data.loss_stop = params.loss_stop;
                }
                // if (params.unrealized_stop_loss_percentage !== undefined) {
                //     body.bu_order_data.unrealized_stop_loss_percentage = params.unrealized_stop_loss_percentage;
                // }
                // if (params.is_multi) {
                //     body.bu_order_data.is_multi = params.is_multi;
                //     if (params.max_active_coins) {
                //         body.bu_order_data.max_active_coins = params.max_active_coins;
                //     }
                // }
            }
            else if (order.trailingStopLimitParam) {
                ///> 追踪止盈单 追踪止损单 ExchangeOrderType.trailingStop || ExchangeOrderType.trailingSell
                orderType = order.trailingStopLimitParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/create`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: order.trailingStopLimitParam.base,
                    quote: order.trailingStopLimitParam.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: TradeTypeDef_1.ExchangeOrderType.trailingStop,
                    bu_order_data: {
                        buy: order.trailingStopLimitParam.buy,
                        trigger: order.trailingStopLimitParam.trigger,
                        trailing_percentage: order.trailingStopLimitParam.trailing_percentage,
                        amount: order.trailingStopLimitParam.amount,
                        loss_stop: order.trailingStopLimitParam.loss_stop,
                    },
                };
            }
            else if (order.aipParam && order.aipParam.type === TradeTypeDef_1.ExchangeOrderType.aip) {
                ///> 急速定投单 ExchangeOrderType.aip
                orderType = order.aipParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/create`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: order.aipParam.base,
                    quote: order.aipParam.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        per_volume: order.aipParam.per_volume,
                        interval: order.aipParam.interval,
                        side: "buy",
                    },
                };
            }
            else if (order.twapParam && order.twapParam.type === TradeTypeDef_1.ExchangeOrderType.twap) {
                ///> 分时交易单 ExchangeOrderType.twap
                orderType = order.twapParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/create`;
                const bu_order_data = {
                    total_volume: order.twapParam.total_volume,
                    total_times: order.twapParam.total_times,
                    side: order.twapParam.side,
                };
                if (order.twapParam.interval) {
                    bu_order_data.interval = order.twapParam.interval;
                }
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: order.twapParam.base,
                    quote: order.twapParam.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: bu_order_data,
                };
            }
            else if (order.igParam && order.igParam.type === TradeTypeDef_1.ExchangeOrderType.ig) {
                ///> 无限网格 ExchangeOrderType.ig
                orderType = order.igParam.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/create`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: order.igParam.base,
                    quote: order.igParam.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        invest: order.igParam.invest,
                        invest_allocate: order.igParam.invest_allocate,
                        bottom: order.igParam.bottom,
                        rate: order.igParam.rate,
                        profit_stop: order.igParam.profit_stop || null,
                        loss_stop: order.igParam.loss_stop || null,
                        invest_coin: order.igParam.invest_coin || null,
                        condition: order.igParam.condition || null,
                        condition_direction: order.igParam.condition_direction || null,
                    },
                };
            }
            else if (order.fsaParams && order.fsaParams.type === TradeTypeDef_1.ExchangeOrderType.fsa) {
                // 期限套利 ExchangeOrderType.fsa
                orderType = order.fsaParams.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                const params = order.fsaParams;
                body = {
                    key_id: key_id,
                    exchange: params.spotExchange,
                    base: params.spotBase,
                    quote: params.spotQuote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        swap_exchange: params.swapExchange,
                        swap_base: params.swapBase,
                        swap_quote: params.swapQuote,
                        investment: params.investment,
                        leverage: params.leverage,
                        direction: params.direction,
                        price_diff_limit: params.price_diff_limit,
                        price_ratio: params.price_ratio || null,
                    },
                };
            }
            else if (order.cm_fsaParams && order.cm_fsaParams.type === TradeTypeDef_1.ExchangeOrderType.cm_fsa) {
                // 币本位期限套利 ExchangeOrderType.cm_fsa
                orderType = order.cm_fsaParams.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                const params = order.cm_fsaParams;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: params.base,
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        swap_exchange: params.swap_exchange,
                        swap_base: params.swap_base,
                        swap_quote: params.swap_quote,
                        investment: params.investment,
                        open_price_diff_limit: params.open_price_diff_limit,
                    },
                };
            }
            else if (order.reverse_fsaParams && order.reverse_fsaParams.type === TradeTypeDef_1.ExchangeOrderType.reverse_fsa) {
                // 反向币本位期限套利 ExchangeOrderType.reverse_fsa
                orderType = order.reverse_fsaParams.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                const params = order.reverse_fsaParams;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: params.base,
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        swap_exchange: params.swap_exchange,
                        swap_base: params.swap_base,
                        swap_quote: params.swap_quote,
                        investment: params.investment,
                        open_price_diff_limit: params.open_price_diff_limit,
                    },
                };
            }
            else if (order.smartCopy && order.smartCopy.type === TradeTypeDef_1.ExchangeOrderType.SC) {
                // 策略跟单
                orderType = order.smartCopy.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                const params = order.smartCopy;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: params.base,
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        profit_stop_maker: !!params.profit_stop_maker,
                        quote_total_investment: params.quote_total_investment,
                        portfolio: params.portfolio,
                        compound: !!params.compound,
                    },
                };
            }
            else if (order.enhancedAipParam && order.enhancedAipParam.type === TradeTypeDef_1.ExchangeOrderType.enhanced_aip) {
                const params = order.enhancedAipParam;
                orderType = params.type;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: "-",
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        side: "buy",
                        trigger_time: params.trigger_time,
                        quote_total_investment: params.quote_total_investment,
                        enable_staking: params.enable_staking || false,
                        portfolio: params.portfolio,
                    },
                };
            }
            else if (order.fstParams) {
                const params = order.fstParams;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/`;
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    base: "-",
                    quote: params.quote,
                    note: order.note || null,
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    bu_order_type: orderType,
                    bu_order_data: {
                        quote_amount: params.quote_amount,
                        portfolio: params.portfolio,
                    },
                };
            }
            else if (order.gridV4FuturesHedgeGrid && orderType === TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid) {
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_hedge_grid/`;
                // 合约多空双开
                body = {
                    bu_order_id: order.bu_order_id,
                    key_id,
                    exchange: this.apiKey.market,
                    copy_from: order.copyFrom || "",
                    copy_type: order.copyType || "",
                    bu_order_data: order.gridV4FuturesHedgeGrid,
                    customize_name: order.customize_name,
                };
                const ob = trade_utils_lib_1.Network.post({ url, data: body, authType: trade_utils_lib_1.AuthType.AccessAndSpot, signature: true }).pipe((0, operators_1.map)((data) => {
                    return {
                        status: data.status,
                        orderId: data.bu_order_id,
                        orderType: orderType,
                        orderData: data,
                    };
                }));
                return ob;
            }
            else if (order.copyBotParams && orderType === TradeTypeDef_1.ExchangeOrderType.copy_bot) {
                const params = order.copyBotParams;
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/`;
                const { quote, customize_name } = params, bu_order_data = __rest(params, ["quote", "customize_name"]);
                body = {
                    key_id: key_id,
                    exchange: this.apiKey.market,
                    quote: params.quote,
                    base: "-",
                    copy_from: order.copyFrom || null,
                    copy_type: order.copyType || null,
                    note: order.note || null,
                    customize_name: params.customize_name,
                    bu_order_type: orderType,
                    bu_order_data: bu_order_data,
                };
                const ob = trade_utils_lib_1.Network.post({ url, data: body, authType: trade_utils_lib_1.AuthType.AccessAndSpot, signature: true }).pipe((0, operators_1.map)((data) => {
                    return {
                        status: data.status,
                        orderId: data.bu_order_id,
                        orderType: orderType,
                        orderData: data,
                    };
                }));
                return ob;
            }
            else {
                throw "not implement order type: " + orderType + "!";
            }
            return [orderType, url, body];
        }), (0, operators_1.switchMap)((resp) => {
            if (Array.isArray(resp)) {
                const [orderType, url, data] = resp;
                if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
                    return trade_utils_lib_1.Network.post({
                        url,
                        data,
                        authType: trade_utils_lib_1.AuthType.AccessAndSpot,
                        signature: true,
                    }).pipe((0, operators_1.map)((data) => {
                        return {
                            status: data.status,
                            orderId: data.bu_order_id,
                            orderType: orderType,
                            orderData: data,
                        };
                    }));
                }
                else if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4Futures || orderType === TradeTypeDef_1.ExchangeOrderType.futures_martingale) {
                    return trade_utils_lib_1.Network.post({
                        url,
                        data,
                        authType: trade_utils_lib_1.AuthType.FullToken,
                        signature: true,
                    }).pipe((0, operators_1.map)((data) => {
                        return {
                            status: data.status,
                            orderId: data.bu_order_id,
                            orderType: orderType,
                            orderData: data,
                        };
                    }));
                }
                else if (orderType === TradeTypeDef_1.ExchangeOrderType.futures_smart_trade) {
                    return trade_utils_lib_1.Network.post({
                        url,
                        data,
                        authType: trade_utils_lib_1.AuthType.FullToken,
                        signature: true,
                    }).pipe((0, operators_1.map)((data) => {
                        return {
                            status: data.status,
                            orderId: data.bu_order_id,
                            orderType: orderType,
                            orderData: data,
                        };
                    }));
                }
                else {
                    return trade_utils_lib_1.NetworkUtils.post({ url: url, data: data, authorize: true, withBearer: false }).pipe((0, operators_1.map)((data) => {
                        return {
                            status: data.status,
                            orderId: data.bu_order_id,
                            orderType: orderType,
                            orderData: data,
                        };
                    }));
                }
            }
            else {
                return resp;
            }
        }));
        return (0, rxjs_1.of)(0).pipe((0, operators_1.mergeMap)(() => {
            if (order.marketParam || order.customParam) {
                return singleOrder$;
            }
            else {
                return botOrder$;
            }
        }));
    }
    queryCustomClosedOrdersRestApi(base, quote, orderId, limit, direct, isManual, includeStrategy) {
        return this.fetchCloseOrders(base, quote, orderId, limit, direct, isManual, includeStrategy);
    }
    queryCustomOpenOrdersRestApi(base, quote, orderId, limit, isManual, includeStrategy, strategyId) {
        return this.fetchOpenOrders(base, quote, orderId, limit, isManual, includeStrategy, strategyId);
    }
    getTrades(base, quote) {
        if (this.baseExchangeAdapterImpl) {
            return this.baseExchangeAdapterImpl.getTrades(base, quote);
        }
        else {
            return this.getTradesWebSocketObservable(base, quote);
        }
    }
    fetchFutureSymbolBalance(symbol) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/${this.apiKey.market}/swap/private/balance/?symbol=${symbol}`;
        return this.keyResolver.requestSigner.getSignRequestV2("GET", url, undefined).pipe((0, operators_1.map)((response) => {
            if (response && response.code === 0) {
                const currencies = response.data.currencies;
                let swapBalance = Object.keys(currencies).map((coin) => {
                    var _a, _b, _c, _d;
                    let coinInfo = currencies[coin];
                    return {
                        currency: coin,
                        currencyAlias: coin.substr(0, coin.length - 5),
                        available: Number(coinInfo.free),
                        frozen: Number(coinInfo.used),
                        balance: Number(coinInfo.total),
                        fullName: coin,
                        balanceType: TradeTypeDef_1.BALANCE_TYPE.SWAP,
                        usdPrice: Number((_a = coinInfo.usd_price) !== null && _a !== void 0 ? _a : 0),
                        usdChangePercent: Number((_b = coinInfo.usd_change_percent) !== null && _b !== void 0 ? _b : 0),
                        btcPrice: Number((_c = coinInfo.btc_price) !== null && _c !== void 0 ? _c : 0),
                        btcChangePercent: Number((_d = coinInfo.btc_change_percent) !== null && _d !== void 0 ? _d : 0),
                    };
                });
                return swapBalance;
            }
            throw response.message ? response.message : "cannot get swap balance";
        }));
    }
    /**
     * @deprecated 已废弃，不需要再调用
     */
    refreshTradingLimitInfoWithSymbol(base, quote) {
        // if (this.apiKey.market.toLowerCase() === "huobi.pro") {
        //     if (this.baseExchangeAdapterImpl) {
        //         this.baseExchangeAdapterImpl.getRefreshTradingLimitInfoObservable(base, quote).subscribe({
        //             next: (result) => {
        //                 this.symbols = this.baseExchangeAdapterImpl.symbols;
        //             },
        //             error: (error) => {},
        //         });
        //     }
        // }
    }
    getRefreshTradingLimitInfoObservable(base, quote) {
        if (this.apiKey.market.toLowerCase() === "huobi.pro") {
            if (this.baseExchangeAdapterImpl) {
                return this.baseExchangeAdapterImpl.getRefreshTradingLimitInfoObservable(base, quote);
            }
        }
        return (0, rxjs_1.of)({
            symbol: "",
            base: base,
            quote: quote,
            baseDisplay: base,
            isLeverage: false,
            quoteDisplay: quote,
            symbolType: trade_utils_lib_1.ExchangeSymbolType.spot,
        });
    }
    takeProfit(bu_order_id) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)(false);
            }
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/take_profit`;
            let body = {
                bu_order_id: bu_order_id,
            };
            let headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), headers, body, (response) => {
                return response.code;
            })
                .pipe((0, operators_1.map)((status) => {
                return status === 0;
            }))
                .pipe((0, operators_1.catchError)((err) => {
                return (0, rxjs_1.of)(false);
            }));
        }));
    }
    /**
     * @deprecated 已废弃, instead by queryDCACustomOrders
     */
    queryAIPOrTWAPCustomOrdersOnce(orderId, pgno = 0, pgnm = 10) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)([]);
            }
            let url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${orderId}/exchange_orders?pgno=${pgno}&pgnm=${pgnm}`, this.extraParamRuntime["commonParam"]);
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, { Authorization: token.toString() }, (response) => {
                let value = response.data;
                return value.map((item) => {
                    const findSymbol = this.symbolMap.get(`${item.base}_${item.quote}`);
                    return {
                        id: item.exchange_order_id,
                        orderType: item.type,
                        base: item.base,
                        quote: item.quote,
                        symbol: item.symbol,
                        baseDisplay: findSymbol ? findSymbol.baseDisplay : item.base,
                        isLeverage: findSymbol ? findSymbol.isLeverage : false,
                        timestamp: item.timestamp,
                        lastTradeTime: item.lastTradeTimestamp,
                        state: TradeUtils_1.TradeUtils.convertState(item.status, true),
                        exchangeCustomOrder: {
                            side: item.side,
                            type: item.type,
                            price: item.price,
                            amount: item.amount,
                            filled_amount: item.filled ? item.filled : 0,
                            filled_value: item.cost ? item.cost : 0,
                            avgDealPrice: item.cost && item.filled ? new decimal_js_1.Decimal(item.cost).div(item.filled).toNumber() : 0,
                            fee: item.fee,
                            feeCoin: item.fee_coin ? item.fee_coin.toUpperCase() : "",
                            feeRefund: item.fee_income_cost,
                            feeRefundCoin: item.fee_income_coin ? item.fee_income_coin.toUpperCase() : "",
                            source: "",
                        },
                    };
                });
            });
        }));
    }
    /**
     * 请求dca类订单的历史记录
     * @param orderId
     * @param pageToken
     * @returns
     */
    queryDCACustomOrders(orderId, pageToken) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderId}/exchange_orders/`;
        return trade_utils_lib_1.ObservableUtils.get(url, pageToken ? { page_token: pageToken } : undefined, undefined, true).pipe((0, operators_1.map)((res) => {
            var _a;
            const arr = ((_a = res.results) !== null && _a !== void 0 ? _a : []);
            const items = arr.map((item) => {
                const findSymbol = this.symbolMap.get(`${item.base}_${item.quote}`);
                return {
                    id: item.exchange_order_id,
                    orderType: item.type,
                    base: item.base,
                    quote: item.quote,
                    symbol: item.symbol,
                    baseDisplay: findSymbol ? findSymbol.baseDisplay : item.base,
                    isLeverage: findSymbol ? findSymbol.isLeverage : false,
                    timestamp: item.timestamp,
                    lastTradeTime: item.lastTradeTimestamp,
                    state: TradeUtils_1.TradeUtils.convertState(item.status, true),
                    isRunning: false,
                    originOrderData: item,
                    exchangeCustomOrder: {
                        side: item.side,
                        type: item.type,
                        price: item.price,
                        amount: item.amount,
                        filled_amount: item.filled ? item.filled : 0,
                        filled_value: item.cost ? item.cost : 0,
                        avgDealPrice: item.cost && item.filled ? new decimal_js_1.Decimal(item.cost).div(item.filled).toNumber() : 0,
                        fee: item.fee,
                        feeCoin: item.fee_coin ? item.fee_coin.toUpperCase() : "",
                        feeRefund: item.fee_income_cost,
                        feeRefundCoin: item.fee_income_coin ? item.fee_income_coin.toUpperCase() : "",
                        source: "",
                    },
                };
            });
            return {
                next_page_token: res.next_page_token,
                previous_page_token: res.previous_page_token,
                results: items,
            };
        }));
    }
    getBotTypeBalance() {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token || !this.shouldCheckStrategyOrder()) {
                return (0, rxjs_1.of)(undefined);
            }
            let url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/order_balance`, this.extraParamRuntime["commonParam"]);
            let headers = {
                Authorization: token.toString(),
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (resp) => {
                var _a, _b;
                let botTypeBalance;
                const tempGridV1 = resp.data.grid ? new trade_utils_lib_1.SafeDecimal(resp.data.grid) : undefined;
                const tempGridClassic = resp.data.grid_classic ? new trade_utils_lib_1.SafeDecimal(resp.data.grid_classic) : undefined;
                const tempGridPro = resp.data.grid_pro ? new trade_utils_lib_1.SafeDecimal(resp.data.grid_pro) : undefined;
                const tempGridV3 = resp.data.grid_v3 ? new trade_utils_lib_1.SafeDecimal(resp.data.grid_v3) : undefined;
                let tempGridV2 = new trade_utils_lib_1.SafeDecimal(0);
                if (tempGridV1 !== undefined) {
                    tempGridV2 = tempGridV2.add(tempGridV1);
                }
                if (tempGridClassic !== undefined) {
                    tempGridV2 = tempGridV2.add(tempGridClassic);
                }
                if (tempGridPro !== undefined) {
                    tempGridV2 = tempGridV2.add(tempGridPro);
                }
                if (tempGridV3 !== undefined) {
                    tempGridV2 = tempGridV2.add(tempGridV3);
                }
                botTypeBalance = {
                    ig: resp.data.ig ? resp.data.ig : undefined,
                    twap: resp.data.twap ? resp.data.twap : undefined,
                    aip: resp.data.aip ? resp.data.aip : undefined,
                    trailing_stop: resp.data.trailing_stop ? resp.data.trailing_stop : undefined,
                    grid_classic: resp.data.grid_classic ? resp.data.grid_classic : undefined,
                    grid_pro: resp.data.grid_pro ? resp.data.grid_pro : undefined,
                    grid_V1: resp.data.grid ? resp.data.grid : undefined,
                    grid_loan: resp.data.loan_grid ? resp.data.loan_grid : undefined,
                    grid_short: resp.data.short_grid ? resp.data.short_grid : undefined,
                    grid_leverage: resp.data.leverage_grid ? resp.data.leverage_grid : undefined,
                    grid: tempGridV2.toString() === "0" ? undefined : tempGridV2.toString(),
                    grid_leverage_short: resp.data.short_leverage_grid ? resp.data.short_leverage_grid : undefined,
                    smart_trade: resp.data.smart_trade ? resp.data.smart_trade : undefined,
                    smart_rebalance: resp.data.smart_rebalance ? resp.data.smart_rebalance : undefined,
                    martingale: (_b = (_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.martingale) !== null && _b !== void 0 ? _b : undefined,
                };
                return botTypeBalance;
            });
        }))
            .pipe((0, operators_1.catchError)(() => {
            return (0, rxjs_1.of)(undefined);
        }));
    }
    getTradesWebSocketObservable(base, quote) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().webSocketHost}/stream`;
        const data = {
            action: "subscribe",
            channel: "trades.history",
            data: [
                {
                    exchange: this.apiKey.market,
                    base: base,
                    quote: quote,
                },
            ],
        };
        const mapResult = (item) => {
            return {
                base: item.base,
                quote: item.quote,
                symobol: item.base.toUpperCase() + "/" + item.quote.toUpperCase(),
                side: item.buyer_maker === true ? "buy" : "sell",
                timestamp: item.timestamp,
                price: item.price,
                amount: item.quantity,
                fee: 0,
                order: item.origin_id,
                id: item.origin_id,
            };
        };
        return (0, BaseWebSocket_1.getWebSocketObservable)(url, data)
            .pipe((0, operators_1.map)((data) => data.data))
            .pipe((0, operators_1.map)((data) => {
            if (data.action && data.action === "since" && data.data) {
                return data.data.map(mapResult);
            }
            return data.map(mapResult);
        }));
    }
    queryDeptAvaliable(coin) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/available_amount`;
        return trade_utils_lib_1.ObservableUtils.get(url, { coin: coin }, null, true);
    }
    queryLeverageTradeInfo(base, quote) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/interest_rate`;
        return trade_utils_lib_1.ObservableUtils.get(url, { base: base, quote: quote }, null, true);
    }
    queryLeverageSupportedConfig() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/leverage_grid/pair_config`;
        const fetchData = (0, trade_utils_lib_1.requestWithRetry)(() => {
            return trade_utils_lib_1.ObservableUtils.get(url, { exchange: this.apiKey.market }, { "Cache-Control": "max-age=0" });
        });
        const modelParam = {
            keyId: this.apiKey.cloudKeyId,
            dataKey: "leverage_pair_supported_config",
            expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
            refresh: () => fetchData,
        };
        return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
    }
    // 追加/提取保证金
    /**
     * @deprecated
     * replace by   transferProfit(orderType: ExchangeOrderType, orderId: string, param: TransferProfitParam): Observable<TransferRecord>
     * @param orderType
     * @param orderId
     * @param param
     */
    transferMargin(orderType, orderId, param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${orderType}/${orderId}/transfer-margin`;
        return trade_utils_lib_1.NetworkUtils.post({ url: url, data: param, authorize: true });
    }
    //查询提取利润记录
    queryTransferRecord(orderType, orderId, transfer_type) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/transfer/`;
        let urlParam = {};
        if (transfer_type) {
            urlParam.type = transfer_type;
        }
        if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures, TradeTypeDef_1.ExchangeOrderType.futures_martingale].includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/transfer/`;
        }
        return trade_utils_lib_1.Network.get({ url, data: urlParam, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((v) => { var _a; return (_a = v.results) !== null && _a !== void 0 ? _a : []; }));
    }
    /**
     * 查询Transfer 记录,包含分页信息
     * @param params
     */
    queryTransferRecordV2(params) {
        let originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${params.orderType}/${params.orderId}/transfer/`;
        if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(params.orderType)) {
            originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/transfer/`;
        }
        let urlParam = {};
        if (params.type) {
            urlParam.type = params.type;
        }
        if (params.page_token) {
            urlParam.page_token = params.page_token;
        }
        return trade_utils_lib_1.Network.get({
            url: originUrl,
            data: urlParam,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((data) => {
            var _a, _b;
            return {
                nextPageToken: (_a = data.next_page_token) !== null && _a !== void 0 ? _a : null,
                orders: (_b = data.results) !== null && _b !== void 0 ? _b : [],
            };
        }));
    }
    /**
     * 查询Transfer 记录,包含分页信息, 特指保证金变更记录，主要是服务端接口不一致
     * @param params
     */
    queryTransferRecordV3(params) {
        let originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${params.orderType}/${params.orderId}/transfer_history/`;
        let requestParam = {
            url: originUrl,
            data: { page_token: params.page_token, type: params.type },
            authType: trade_utils_lib_1.AuthType.Access,
        };
        if (params.orderType === TradeTypeDef_1.ExchangeOrderType.futures_smart_trade) {
            originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/transfer_history/`;
            requestParam = {
                url: originUrl,
                data: { page_token: params.page_token, type: params.type },
                authType: trade_utils_lib_1.AuthType.FullToken,
            };
        }
        return trade_utils_lib_1.Network.get(requestParam).pipe((0, operators_1.map)((data) => {
            var _a, _b;
            return {
                nextPageToken: (_a = data.next_page_token) !== null && _a !== void 0 ? _a : null,
                orders: (_b = data.results) !== null && _b !== void 0 ? _b : [],
            };
        }));
    }
    /**
     * 合约追踪平仓
     * @param params
     */
    futuresSmartTradeClosePosition(params) {
        const originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/liquidate/`;
        const requestParam = {
            url: originUrl,
            data: { mode: params.mode, price: params.price, quantity: params.quantity },
            authType: trade_utils_lib_1.AuthType.FullToken,
        };
        return trade_utils_lib_1.Network.post(requestParam);
    }
    /**
     * 修改追踪参数
     * @param params
     */
    modifyFSTOrderTPSL(params) {
        const originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/edit_tpsl/`;
        const requestParam = {
            url: originUrl,
            data: { tp_sl: params.tp_sl },
            authType: trade_utils_lib_1.AuthType.FullToken,
        };
        return trade_utils_lib_1.Network.post(requestParam);
    }
    //提取利润
    transferProfit(orderType, orderId, param) {
        let url;
        let params;
        switch (orderType) {
            case TradeTypeDef_1.ExchangeOrderType.copy_bot:
            case TradeTypeDef_1.ExchangeOrderType.gridV4Futures:
            case TradeTypeDef_1.ExchangeOrderType.gridV5:
            case TradeTypeDef_1.ExchangeOrderType.futures_martingale:
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/transfer/`;
                params = {
                    url: url,
                    data: param,
                    authType: trade_utils_lib_1.AuthType.Access,
                };
                break;
            case TradeTypeDef_1.ExchangeOrderType.futures_smart_trade:
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/transfer/`;
                params = {
                    url: url,
                    data: param,
                    authType: trade_utils_lib_1.AuthType.FullToken,
                };
                break;
            default:
                url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/transfer/`;
                params = {
                    url: url,
                    data: param,
                    authType: trade_utils_lib_1.AuthType.Access,
                };
                break;
        }
        return trade_utils_lib_1.Network.post(params);
    }
    // 多空双开提取利润
    hedgeGridTransferProfit(orderId, param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_hedge_grid/${orderId}/transfer/`;
        return trade_utils_lib_1.Network.get({ url, data: param, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((r) => {
            return {
                orders: r.results,
                nextPageToken: r.next_page_token,
            };
        }));
    }
    //获取网格可提取利润
    getAllReleaseProfit() {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/orders/extractable_profit/`;
        return trade_utils_lib_1.Network.get({ url, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((data) => {
            return data && data.records
                ? data.records.map((item) => ({
                    orderId: item.bu_order_id,
                    orderType: item.bu_order_type,
                    base: item.base,
                    quote: item.quote,
                    maxAmount: item.max_amount,
                    symbol: item.symbol,
                    withdrawCurrency: item.withdraw_currency,
                    shareRatio: item.share_ratio,
                }))
                : [];
        }));
    }
    queryCurrentDayProfitAndLoss() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/assets/today`;
        return trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, true).pipe((0, operators_1.map)((data) => {
            let botAssets = [];
            if (data.bot_assets.length) {
                const totalInvest = data.bot_assets.reduce((sum, item) => sum + Number(item.investment), 0);
                const result = data.bot_assets
                    .sort((a, b) => Number(b.investment) - Number(a.investment))
                    .map((item) => {
                    var _a, _b, _c, _d, _e, _f;
                    const assets_total_in_usd = Number(item.assets_total_in_usd);
                    const investment = Number(item.investment);
                    const profitToday = Number(item.profit_today);
                    const symbolInfo = this.symbolMap.get(`${item.base}_${item.quote}`);
                    // 轮动base单独处理
                    let _base = item.base;
                    let _baseDisplay = symbolInfo ? symbolInfo.baseDisplay : item.base;
                    if (item.bu_order_type === "smart_rebalance" || item.bu_order_type === "martingale") {
                        let baseResult = [];
                        let baseDisplayResult = [];
                        (_b = (_a = item.bu_order_data) === null || _a === void 0 ? void 0 : _a.portfolio) === null || _b === void 0 ? void 0 : _b.filter((a) => !a.is_deleted).map((portfolio) => {
                            const symbolInfo = this.symbolMap.get(`${portfolio.base}_USDT`);
                            baseResult.push(portfolio.base);
                            baseDisplayResult.push(symbolInfo ? symbolInfo.baseDisplay : portfolio.base);
                        });
                        if (baseResult) {
                            _base = baseResult.join("/");
                        }
                        if (baseDisplayResult) {
                            _baseDisplay = baseDisplayResult.join("/");
                        }
                        if (typeof ((_c = item.bu_order_data) === null || _c === void 0 ? void 0 : _c.user_order_name) === "string") {
                            _baseDisplay = (_d = item.bu_order_data) === null || _d === void 0 ? void 0 : _d.user_order_name;
                        }
                    }
                    return {
                        assetsTotalInUSD: assets_total_in_usd,
                        base: _base,
                        quote: item.quote,
                        baseDisplay: _baseDisplay,
                        buOrderId: item.bu_order_id,
                        buOrderType: item.bu_order_type,
                        exchange: item.exchange,
                        investment: investment,
                        profitToday: profitToday,
                        investPercent: new trade_utils_lib_1.SafeDecimal(investment / totalInvest)
                            .mul(100)
                            .toDecimalPlaces(2, decimal_js_1.Decimal.ROUND_DOWN)
                            .toNumber(),
                        historyProfit: new trade_utils_lib_1.SafeDecimal(item.total_profit).toNumber(),
                        subBuOrderType: (_e = item === null || item === void 0 ? void 0 : item.bu_order_data) === null || _e === void 0 ? void 0 : _e.bu_order_sub_type,
                        isLeverage: (_f = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.isLeverage) !== null && _f !== void 0 ? _f : false,
                    };
                });
                const totalPercent = result.reduce((sum, item) => sum + item.investPercent, 0);
                if (totalPercent !== 100) {
                    result[result.length - 1].investPercent = new trade_utils_lib_1.SafeDecimal(result[result.length - 1].investPercent)
                        .add(new decimal_js_1.Decimal(100).sub(totalPercent).toNumber())
                        .toNumber();
                }
                botAssets = result;
            }
            return {
                botAssets: botAssets,
                initAssets: Number(data.init_assets),
                withdraw: new trade_utils_lib_1.SafeDecimal(data.withdraw).toNumber(),
                deposit: new trade_utils_lib_1.SafeDecimal(data.deposit).toNumber(),
            };
        }));
    }
    changeOrderTriggerPrices(params) {
        let postBody = [
            {
                type: params.priceType,
            },
        ];
        if (params.direction) {
            postBody[0].direction = Number(params.direction);
        }
        if (params.highTriggerPrices) {
            postBody[0].stop_high_price = params.highTriggerPrices;
        }
        if ([TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(params.orderType)) {
            postBody[0].value = params.triggerPrices;
            if (params.triggerPrices) {
                postBody[0].limit_price = params.limitPrice;
            }
            else {
                postBody[0].limit_price = null;
            }
            if (params.trend === TradeTypeDef_1.GridFuturesTrend.no_trend) {
                if (params.highTriggerPrices) {
                    postBody[0].limit_high_price = params.limitHighPrice;
                }
                else {
                    postBody[0].limit_high_price = null;
                }
            }
        }
        else {
            postBody[0].price = params.triggerPrices;
        }
        if (params.stopDelay !== undefined) {
            if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(params.orderType)) {
                postBody[0].stop_delay = Number(params.stopDelay);
            }
            else {
                postBody[0].stop_delay = params.stopDelay;
            }
        }
        if (params.stopType) {
            postBody[0].stop_type = params.stopType;
        }
        // 合约网格外层需要使用list字段包裹
        if ([TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(params.orderType)) {
            postBody = { list: postBody };
        }
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${params.orderType}/${params.orderId}/trigger_price/`;
        if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures, TradeTypeDef_1.ExchangeOrderType.futures_martingale].includes(params.orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/trigger_price/`;
        }
        return trade_utils_lib_1.Network.post({
            url: url,
            authType: trade_utils_lib_1.AuthType.Access,
            data: postBody,
        });
    }
    querySLProOrderList(params) {
        let originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/stop_limit_pro/`;
        if (params.keyId) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}key_id=${params.keyId}`;
        }
        if (params.exchange) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}exchange=${params.exchange}`;
        }
        if (params.status) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}status=${params.status}`;
        }
        if (params.pageToken) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}page_token=${params.pageToken}`;
        }
        if (params.base && params.quote) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}base=${params.base}&quote=${params.quote}`;
        }
        let url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(originUrl, this.extraParamRuntime["commonParam"]);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (data) => {
                return {
                    nextPageToken: data.data.next_page_token ? data.data.next_page_token : undefined,
                    orders: data.data.results.map((item) => {
                        return TradeUtils_1.TradeUtils.convertToExchangeOrder(item);
                    }),
                };
            });
        }));
    }
    queryBotExchangeCloseOrderList(orderId, orderType, tag) {
        let url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/closed_exchange_orders/`);
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5 || orderType === TradeTypeDef_1.ExchangeOrderType.gridV4) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/closed_exchange_orders/`;
        }
        return trade_utils_lib_1.Network.get({
            url,
            data: { tag: tag || "close_position" },
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((data) => {
            return data["results"].map((item) => {
                return {
                    id: item.exchange_order_id,
                    orderType: item.type,
                    base: item.base,
                    quote: item.quote,
                    exchange: item.exchange,
                    symbol: item.symbol,
                    timestamp: item.timestamp,
                    isLeverage: false,
                    baseDisplay: "",
                    lastTradeTime: item.lastTradeTimestamp,
                    state: item.status,
                    isRunning: false,
                    exchangeCustomOrder: {
                        side: item.side,
                        type: item.type,
                        price: item.price,
                        amount: item.amount,
                        filled_amount: item.filled,
                        filled_value: item.cost,
                        fee: item.fee,
                        avgDealPrice: item.average,
                        feeCoin: item.fee_coin,
                        feeInQuote: item.fee_in_quote,
                        feeRefund: item.fee_refund_in_quote,
                    },
                };
            });
        }));
    }
    getQueryAllMarketBotOrdersMoreV3(params) {
        let originUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/`;
        if (params.orderType) {
            originUrl += `${params.orderType}/`;
        }
        if (params.exchange) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}exchange=${params.exchange}`;
        }
        if (params.status) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}status=${params.status}`;
        }
        if (params.pageToken) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}page_token=${params.pageToken}`;
        }
        if (params.pair) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}base=${params.pair.base}&quote=${params.pair.quote}`;
        }
        if (params.copyType) {
            let result = originUrl.indexOf("?") === -1 ? "?" : "&";
            originUrl += `${result}copy_type=${params.copyType}`;
        }
        let url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(originUrl, this.extraParamRuntime["commonParam"]);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (data) => {
                return {
                    nextPageToken: data.data.next_page_token ? data.data.next_page_token : undefined,
                    orders: data.data.results
                        .map((item) => {
                        return TradeUtils_1.TradeUtils.convertToExchangeOrder(item);
                    })
                        .filter((item1) => item1 !== undefined),
                };
            });
        }));
    }
    queryAllBotOrdersV4(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/v2/`;
        let urlParam = {};
        if (params.orderTypes) {
            urlParam.bu_order_types = params.orderTypes.toString();
        }
        if (params.exchange) {
            urlParam.exchange = params.exchange;
        }
        if (params.status) {
            urlParam.status = params.status;
        }
        if (params.pageToken) {
            urlParam.page_token = params.pageToken;
        }
        if (params.pair) {
            urlParam.base = params.pair.base;
            urlParam.quote = params.pair.quote;
        }
        if (params.copyType) {
            urlParam.copy_type = params.copyType;
        }
        return trade_utils_lib_1.NetworkUtils.getV2({ url: url, data: urlParam, authorize: true }).pipe((0, operators_1.map)((data) => {
            const parseData = {
                nextPageToken: data.next_page_token,
                orders: data.results
                    .map((item) => {
                    return TradeUtils_1.TradeUtils.convertToExchangeOrder(item);
                })
                    .filter((item1) => item1 !== undefined),
            };
            return parseData;
        }), (0, operators_1.catchError)((error, e) => {
            if ((error === null || error === void 0 ? void 0 : error.code) === -10001) {
                (0, trade_token_lib_1.acquireKeyResolver)().tradingTokenManager.updateAccessToken();
            }
            return (0, rxjs_1.throwError)(error);
        }));
    }
    queryFutureFundingRate(base, quote, exchange) {
        if ((0, OrderDescUtils_1.checkMarketSupportV2Api)(exchange)) {
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/${exchange}/swap/public/last_funding_rate/`;
            return trade_utils_lib_1.ObservableUtils.get(url, { symbol: `${base}/${quote}` }, null, false).pipe((0, operators_1.map)((result) => {
                return {
                    funding_rate: result[0].last_funding_rate,
                    time: result[0].next_funding_time,
                };
            }));
        }
        else {
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/funding_rate`;
            return trade_utils_lib_1.ObservableUtils.get(url, { base: base, quote: quote, exchange: exchange }, null, true);
        }
    }
    /** 多空双开合约网格 关单 */
    hedgeGridCloseOrder({ id, data }) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_hedge_grid/${id}/cancel/`;
        return trade_utils_lib_1.Network.post({ url, data, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((resp) => ({ orderType: TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid, id, data: resp })));
    }
    interruptFsaAdjustPosition(orderType, orderId) {
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            if (!token) {
                return (0, rxjs_1.of)(undefined);
            }
            // 网格2.0路径
            let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/interrupt/`;
            let headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(url, this.extraParamRuntime["commonParam"]), headers, {}, (resp) => {
                if (resp.code === 0) {
                    return orderId;
                }
                return "";
            });
        }));
    }
    //////////////////////////////////////////////////资产API/////////////////////////////////////////
    requestCoinAddress(coin) {
        return this.assetAPIImpl.requestCoinAddress(coin);
    }
    fetchDepositWithdrawHistory(coin, type, startTime) {
        return this.assetAPIImpl.fetchDepositWithdrawHistory(coin, type, startTime);
    }
    fetchDepositWithdrawHistoryV2(coin, type, startTime) {
        return this.assetAPIImpl.fetchDepositWithdrawHistoryV2(coin, type, startTime);
    }
    withdraw(param) {
        return this.assetAPIImpl.withdraw(param);
    }
    withdrawV2(param) {
        return this.assetAPIImpl.withdrawV2(param);
    }
    cancelWithdraw(id) {
        return this.assetAPIImpl.cancelWithdraw(id);
    }
    requestAllBrokerCoins() {
        return this.assetAPIImpl.requestAllBrokerCoins();
    }
    requestAllBrokerCoinsV2() {
        return this.assetAPIImpl.requestAllBrokerCoinsV2();
    }
    parseProtocolToDisplay(coinName, protocol) {
        return this.assetAPIImpl.parseProtocolToDisplay(coinName, protocol);
    }
    fetchVerifyCode(verifyCodeType) {
        return this.assetAPIImpl.fetchVerifyCode(verifyCodeType);
    }
    requestMoveRecords(coin) {
        return this.assetAPIImpl.requestMoveRecords(coin);
    }
    //现货和基金的今日0点资产
    getSpotAndFundTodayInitAsset() {
        let url = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/assets/today_init`, this.extraParamRuntime["commonParam"]);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(url, headers, (response) => {
                let data = response.data;
                return {
                    spotInitAssets: new trade_utils_lib_1.SafeDecimal(data.spot_init_assets).toNumber(),
                    fundInitAssets: new trade_utils_lib_1.SafeDecimal(data.fund_init_assets).toNumber(),
                    futureInitAssets: new trade_utils_lib_1.SafeDecimal(data.future_init_assets).toNumber(),
                    deposit: new trade_utils_lib_1.SafeDecimal(data.deposit).toNumber(),
                    withdraw: new trade_utils_lib_1.SafeDecimal(data.withdraw).toNumber(),
                };
            });
        }));
    }
    convertStableCoin(source, target, sourceAmount) {
        let queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/convert/`;
        const params = {
            source_coin: source,
            target_coin: target,
            source_amount: sourceAmount,
        };
        return this.keyResolver.requestSigner.getSignRequestV2("POST", encodeURI(queryUrl), JSON.stringify(params)).pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                return result.data;
            }
            throw result;
        }));
    }
    querySymbolStatus(symbol) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/symbol_status/?symbol=${symbol.base}/${symbol.quote}`, this.extraParamRuntime["commonParam"]);
        return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, undefined, (resp) => {
            return resp;
        })
            .pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                const tempBase = (0, TradeUtils_1.TransferToSymbol)(result.data.symbol).base;
                const tempQuote = (0, TradeUtils_1.TransferToSymbol)(result.data.symbol).quote;
                const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
                return {
                    base: tempBase,
                    baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(tempBase, tempQuote, ExchangeID_1.ExchangeID.PIONEXV2).baseDisplay,
                    quote: tempQuote,
                    status: result.data.state,
                };
            }
            else {
                throw JSON.stringify(result);
            }
        }))
            .pipe((0, operators_1.catchError)(() => {
            const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
            return (0, rxjs_1.of)({
                base: symbol.base,
                quote: symbol.quote,
                status: 0,
                baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(symbol.base, symbol.quote, ExchangeID_1.ExchangeID.PIONEXV2).baseDisplay,
            });
        }));
    }
    queryCoinTransferInfo() {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/spot_futures_coins/`, this.extraParamRuntime["commonParam"]);
        return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, undefined, (resp) => {
            return resp;
        })
            .pipe((0, operators_1.map)((result) => {
            var _a, _b, _c, _d;
            if (result.code === 0) {
                const futureInfos = ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.futures_coins) !== null && _b !== void 0 ? _b : []).map((item) => {
                    return {
                        coin: item.coin,
                        futureCoinStatus: item.futures_coin,
                        futureUsdtStatus: item.futures_usdt,
                    };
                });
                const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
                const spotInfos = ((_d = (_c = result.data) === null || _c === void 0 ? void 0 : _c.spot_coins) !== null && _d !== void 0 ? _d : []).map((item) => {
                    const tempBase = (0, TradeUtils_1.TransferToSymbol)(item.symbol).base;
                    const tempQuote = (0, TradeUtils_1.TransferToSymbol)(item.symbol).quote;
                    return {
                        base: tempBase,
                        quote: tempQuote,
                        baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(tempBase, tempQuote, ExchangeID_1.ExchangeID.PIONEXV2).baseDisplay,
                        status: item.state,
                    };
                });
                return {
                    futureCoins: futureInfos,
                    spotCoins: spotInfos,
                };
            }
            else {
                throw JSON.stringify(result);
            }
        }))
            .pipe((0, operators_1.catchError)(() => {
            return (0, rxjs_1.of)({
                futureCoins: [],
                spotCoins: [],
            });
        }));
    }
    //策略冻结信息
    fetchPionexStrategyBalance(strategyId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/strategy_balance/`;
        const getUrlParams = {
            limit: 20,
        };
        if (strategyId) {
            getUrlParams.strategy_id = strategyId;
        }
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils._buildUrlWithParam(url, getUrlParams);
        return (0, trade_token_lib_1.acquireKeyResolver)()
            .requestSigner.getSignRequestV2("GET", urlWithCommonParam, undefined)
            .pipe((0, operators_1.map)((res) => {
            const strategiesArr = res.data.strategies;
            const result = [];
            if (Array.isArray(strategiesArr)) {
                strategiesArr.map((item) => {
                    const strategyBalance = {
                        balances: [],
                        strategyId: item.strategy_id,
                        strategyTag: item.strategy_tag,
                    };
                    if (Array.isArray(item.balances)) {
                        strategyBalance.balances = item.balances.map((balance) => ({
                            coin: balance.coin,
                            free: new trade_utils_lib_1.SafeDecimal(balance.free).toNumber(),
                            frozen: new trade_utils_lib_1.SafeDecimal(balance.frozen).toNumber(),
                        }));
                    }
                    result.push(strategyBalance);
                });
            }
            return result;
        }));
    }
    querySROrderRecords(param) {
        let localParam = {};
        if (param.nextPageToken) {
            localParam.page_token = param.nextPageToken;
        }
        if (param.status) {
            localParam.status = param.status;
        }
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils._buildUrlWithParam(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${param.orderType}/${param.orderId}/rebalance_records/`, localParam);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, headers, (resp) => {
                const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
                return {
                    nextPageToken: resp.data.next_page_token ? resp.data.next_page_token : undefined,
                    records: resp.data.results.map((item) => {
                        return {
                            recordId: item.rebalance_record_id,
                            timestamp: item.create_time,
                            status: item.status,
                            type: item.type,
                            adjustInvestmentAmount: item.adjust_investment_amount
                                ? Number(item.adjust_investment_amount)
                                : undefined,
                            adjustInvestmentNominalAmount: item.adjust_investment_nominal_amount
                                ? Number(item.adjust_investment_nominal_amount)
                                : undefined,
                            detail: item.detail
                                ? item.detail.map((item1) => {
                                    var _a, _b;
                                    return {
                                        recordId: item1.rebalance_record_id,
                                        base: item1.base,
                                        baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(item1.base, param.quote, ExchangeID_1.ExchangeID.PIONEXV2)
                                            .baseDisplay,
                                        side: item1.side,
                                        amount: Number((_a = item1.amount) !== null && _a !== void 0 ? _a : 0),
                                        averagePrice: Number((_b = item1.average) !== null && _b !== void 0 ? _b : 0),
                                    };
                                })
                                : [],
                            noRecord: !item.detail,
                        };
                    }),
                };
            });
        }));
    }
    querySymbolsStatus() {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost}/symbols_status/`, this.extraParamRuntime["commonParam"]);
        return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, undefined, (resp) => {
            if (Array.isArray(resp.data)) {
                return resp.data.map((item) => {
                    const tempBase = (0, TradeUtils_1.TransferToSymbol)(item.symbol).base;
                    const tempQuote = (0, TradeUtils_1.TransferToSymbol)(item.symbol).quote;
                    const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
                    return {
                        base: tempBase,
                        baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(tempBase, tempQuote, ExchangeID_1.ExchangeID.PIONEXV2).baseDisplay,
                        quote: tempQuote,
                        status: item.state,
                    };
                });
            }
            else {
                return [];
            }
        });
    }
    queryManualOrders(param) {
        let localParam = {};
        if (param.symbol) {
            localParam.symbol = `${param.symbol.base}/${param.symbol.quote}`;
        }
        if (param.limit) {
            localParam.limit = param.limit;
        }
        if (param.fromId) {
            localParam.from_id = param.fromId;
        }
        if (param.includeStrategy !== undefined) {
            localParam.include_strategy = param.includeStrategy;
        }
        if (param.direct) {
            localParam.direct = param.direct;
        }
        if (param.state === TradeTypeDef_1.ManualOrderStatus.running) {
            localParam.state = "SUBMITTED,CONFIRMED,PARTIAL_FILLED";
        }
        else if (param.state === TradeTypeDef_1.ManualOrderStatus.finished) {
            localParam.state = "FILLED,CANCELED";
        }
        else if (param.state === TradeTypeDef_1.ManualOrderStatus.filled) {
            localParam.state = "FILLED";
        }
        else if (param.state === TradeTypeDef_1.ManualOrderStatus.canceled) {
            localParam.state = "CANCELED";
        }
        let queryUrl = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().pionexSpotApiHost}/all_orders/`;
        const queryString = Object.keys(localParam)
            .filter((key) => localParam[key] !== undefined)
            .map((key) => {
            return `${key}=${encodeURIComponent(localParam[key])}`;
        }, [])
            .join("&");
        if (queryString) {
            queryUrl = `${queryUrl}${queryUrl.includes("?") ? "&" : "?"}${queryString}`;
        }
        return this.keyResolver.requestSigner.getSignRequestV2("GET", queryUrl, undefined).pipe((0, operators_1.map)((result) => {
            if (result.code === 0) {
                if (!result.data) {
                    return [];
                }
                return result.data
                    .map((item) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const order = {
                        id: item.id,
                        datetime: item.datetime,
                        timestamp: item.timestamp,
                        lastTradeTimestamp: item.last_trade_timestamp,
                        status: item.status,
                        symbol: item.symbol,
                        type: item.type,
                        side: item.side,
                        average: item.average == null ? undefined : Number((_a = item.average) !== null && _a !== void 0 ? _a : 0),
                        price: Number((_b = item.price) !== null && _b !== void 0 ? _b : 0),
                        amount: Number((_c = item.amount) !== null && _c !== void 0 ? _c : 0),
                        filled: Number((_d = item.filled) !== null && _d !== void 0 ? _d : 0),
                        remaining: Number((_e = item.remaining) !== null && _e !== void 0 ? _e : 0),
                        cost: Number((_f = item.cost) !== null && _f !== void 0 ? _f : 0),
                        trades: item.trades,
                        fee: item.fee
                            ? {
                                type: item.fee.type,
                                currency: item.fee.currency,
                                rate: Number((_g = item.fee.rate) !== null && _g !== void 0 ? _g : 0),
                                cost: Number((_h = item.fee.cost) !== null && _h !== void 0 ? _h : 0),
                            }
                            : null,
                        info: item.info,
                    };
                    return order;
                })
                    .filter((obj) => obj.type === TradeTypeDef_1.ExchangeOrderType.limit || obj.type === TradeTypeDef_1.ExchangeOrderType.market)
                    .map((order) => {
                    let arr = order.symbol.split("/");
                    const symbolInfo = this.symbolMap.get(`${arr[0]}_${arr[1]}`);
                    return TradeUtils_1.TradeUtils.convertToExchangeOrder(order, symbolInfo);
                });
            }
            throw JSON.stringify(result);
        }));
    }
    queryBotOrderCount() {
        const queryUrl = trade_utils_lib_1.ObservableUtils._buildUrlWithParam(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/statistical/quantity/`);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(queryUrl, headers, (data) => {
                var _a;
                return (_a = data.data) === null || _a === void 0 ? void 0 : _a.map((item) => {
                    return {
                        orderType: item.bu_order_type,
                        count: item.num,
                    };
                });
            });
        }));
    }
    modifySRBotName(name, orderType, orderId) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/rename/`, this.extraParamRuntime["commonParam"]);
        const body = {
            user_order_name: name,
        };
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, headers, JSON.stringify(body), (resp) => {
                return resp;
            }).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return result.data.user_order_name;
                }
                throw JSON.stringify(result);
            }));
        }));
    }
    smartRebalanceUpdatePortfolio(orderId, portfolio, allocateOut) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${TradeTypeDef_1.ExchangeOrderType.SR}/${orderId}/update_portfolio/`;
        const data = JSON.stringify({ portfolio: portfolio, allocate_out: !!allocateOut });
        return trade_utils_lib_1.ObservableUtils.post(url, data, undefined, true);
    }
    modifySRRules(param, orderType, orderId) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/update_rebalance_param/`, this.extraParamRuntime["commonParam"]);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, headers, JSON.stringify(param), (resp) => {
                return resp;
            }).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    return result.data;
                }
                throw JSON.stringify(result);
            }));
        }));
    }
    querySRModifyCoinRecord(orderId) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_rebalance/${orderId}/snapshots/`, this.extraParamRuntime["commonParam"]);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createGetRequestObservable(urlWithCommonParam, headers, (resp) => {
                return resp;
            }).pipe((0, operators_1.map)((result) => {
                if (result.code === 0) {
                    const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
                    return result.data.map((item) => {
                        return {
                            portfolio: item.portfolio.map((item1) => {
                                return {
                                    snapshotId: item1.snapshot_id,
                                    base: item1.base,
                                    baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(item1.base, item.quote, ExchangeID_1.ExchangeID.PIONEXV2)
                                        .baseDisplay,
                                    percent: item1.percent,
                                    price: item1.price,
                                    currentBaseAmount: Number(item1.current_base_amount),
                                    isDeleted: item1.is_deleted,
                                };
                            }),
                            snapshotId: item.snapshot_id,
                            currentQuoteAmount: Number(item.current_quote_amount),
                            createTime: item.create_time,
                            quote: item.quote,
                        };
                    });
                }
                throw JSON.stringify(result);
            }));
        }));
    }
    allocateSRSmallBalance(orderId) {
        let urlWithCommonParam = trade_utils_lib_1.ObservableUtils.buildUrlWithCommonParams(`${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_rebalance/${orderId}/transfer/`, this.extraParamRuntime["commonParam"]);
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const headers = {
                Authorization: token,
                "Content-Type": "application/json;charset=UTF-8",
            };
            const postParam = {
                type: "allocate_out",
                direction: "out",
                coin: "_",
            };
            return trade_utils_lib_1.ObservableUtils.createPostRequestObservable(urlWithCommonParam, headers, JSON.stringify(postParam), (resp) => {
                return resp;
            }).pipe((0, operators_1.map)((result) => {
                return result.code === 0;
            }));
        }));
    }
    fetchFutureSpotIncome(orderId, nexPageToken) {
        return this.fetchOrderIncomes(orderId, TradeTypeDef_1.ExchangeOrderType.fsa, nexPageToken);
    }
    fetchOrderIncomes(orderId, orderType, nexPageToken, incomeTypeIn) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/incomes/`;
        if (incomeTypeIn !== undefined) {
            url = `${url}?income_type__in=${incomeTypeIn.join(",")}`;
        }
        const param = nexPageToken ? { page_token: nexPageToken } : undefined;
        return trade_utils_lib_1.ObservableUtils.get(url, param, undefined, true);
    }
    /**
     * 查询存币生息支持的币种
     * @param coin
     */
    queryFMCoins(coin) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/coins/`;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam, coin ? { coin: coin } : undefined).pipe((0, operators_1.map)((data) => {
            var _a;
            if (data.coins) {
                return (_a = data.coins) === null || _a === void 0 ? void 0 : _a.map((a) => {
                    return {
                        canInvest: a.can_invest,
                        canRedeem: a.can_redeem,
                        coin: a.coin,
                        dailyInterest: a.daily_interest,
                        InvestQuota: a.invest_quota,
                        leftInvestQuota: a.left_invest_quota,
                        leftRedeemQuota: a.left_redeem_quota,
                        minInvest: a.min_invest,
                        minRedeem: a.min_redeem,
                        redeemQuota: a.redeem_quota,
                    };
                });
            }
            else {
                return [];
            }
        }));
    }
    /**
     * 存币生息申购
     * @param param
     */
    investFMCoin(param) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/invest/`;
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, tradeRequestParam, param).pipe((0, operators_1.map)((data) => {
            return data.client_deposit_id;
        }));
    }
    /**
     * 查询单笔申购
     * @param recordId
     */
    queryFMCoinInvest(recordId) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/invest/`;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam, { client_deposit_id: recordId }).pipe((0, operators_1.map)((data) => {
            const a = data;
            return {
                amount: a.amount,
                clientDepositId: a.client_deposit_id,
                coin: a.coin,
                confirmTime: a.confirm_time,
                createTime: a.create_time,
                depositType: a.deposit_type,
                status: a.status,
                fee: a.fee,
                reason: a.reason,
            };
        }));
    }
    /**
     * 存币生息赎回
     * @param param
     */
    redeemFMCoin(param) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/redeem/`;
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, tradeRequestParam, param).pipe((0, operators_1.map)((data) => {
            return data.client_deposit_id;
        }));
    }
    /**
     * 查询单笔赎回
     * @param recordId
     */
    queryFMCoinRedeem(recordId) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const params = { client_deposit_id: recordId };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/redeem/`;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam, params).pipe((0, operators_1.map)((data) => {
            const a = data;
            return {
                amount: a.amount,
                clientDepositId: a.client_deposit_id,
                coin: a.coin,
                confirmTime: a.confirm_time,
                createTime: a.create_time,
                depositType: a.deposit_type,
                status: a.status,
                fee: a.fee,
            };
        }));
    }
    /**
     * 查询申赎记录
     * @param param
     */
    queryFMTransactions(param) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const headerParam = param.coin ? Object.assign(Object.assign({}, param), { coin: param.coin.toString() }) : param;
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/records/`;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam, headerParam).pipe((0, operators_1.map)((data) => {
            var _a;
            if (data.records) {
                return (_a = data.records) === null || _a === void 0 ? void 0 : _a.map((a) => {
                    return {
                        amount: a.amount,
                        clientDepositId: a.client_deposit_id,
                        coin: a.coin,
                        confirmTime: a.confirm_time,
                        createTime: a.create_time,
                        depositType: a.deposit_type,
                        status: a.status,
                        fee: a.fee,
                    };
                });
            }
            else {
                return [];
            }
        }));
    }
    /**
     * 查询存币生息持仓
     */
    queryFMPositions() {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/positions/`;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam).pipe((0, operators_1.map)((data) => {
            if (data.positions) {
                return data.positions;
            }
            else {
                return [];
            }
        }));
    }
    /**
     * 存币生息提取利息
     * @param param
     */
    releaseFMInterest(param) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/collect/`;
        return trade_utils_lib_1.ObservableUtils.postWithAccessAndSpotAuth(url, tradeRequestParam, param).pipe((0, operators_1.map)((data) => {
            return data.client_deposit_id;
        }));
    }
    /**
     * 查询存币生息利息记录
     * @param param
     */
    queryFMInterestRecord(param) {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/interests/`;
        const params = param.coin ? Object.assign(Object.assign({}, param), { coin: param.coin.toString() }) : param;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam, params).pipe((0, operators_1.map)((data) => {
            if (data.interests) {
                return data.interests;
            }
            else {
                return [];
            }
        }));
    }
    /**
     * 查询利息总览
     */
    queryFMInterestAggregate() {
        const tradeRequestParam = {
            market: this.apiKey.market,
            apiKey: this.apiKey.key,
            cloudKeyId: this.apiKey.cloudKeyId,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().FM_HOST}/deposit/accrue/`;
        return trade_utils_lib_1.ObservableUtils.getWithAccessAndSpotAuth(url, tradeRequestParam).pipe((0, operators_1.map)((data) => {
            if (data.accrues) {
                return data.accrues;
            }
            else {
                return [];
            }
        }));
    }
    /**
     * 查询MTG 当前挂单
     * @param orderId
     */
    queryMTGCurrentRound(orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/current_round/`;
        return trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, true).pipe((0, operators_1.map)((value) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const item = value;
            if (item) {
                return {
                    exchangeOrders: item.exchange_orders
                        ? (_a = item.exchange_orders) === null || _a === void 0 ? void 0 : _a.map((obj) => {
                            const symbolInfo = this.symbolMap.get(`${obj.base}_${obj.quote}`);
                            return {
                                id: obj.exchange_order_id,
                                orderType: obj.type,
                                base: obj.base,
                                quote: obj.quote,
                                symbol: obj.symbol,
                                timestamp: obj.timestamp,
                                tag: obj.tag,
                                state: TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0),
                                baseDisplay: symbolInfo ? symbolInfo.baseDisplay : obj.base,
                                isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                                isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0)),
                                originOrderData: obj,
                                exchangeCustomOrder: {
                                    side: obj.side,
                                    type: obj.type,
                                    price: Number(obj.price),
                                    amount: Number(obj.amount),
                                    filled_amount: obj.filled ? Number(obj.filled) : 0,
                                    avgDealPrice: obj.average ? Number(obj.average) : 0,
                                    filled_value: obj.cost ? Number(obj.cost) : 0,
                                    feeInQuote: obj.fee_in_quote ? Number(obj.fee_in_quote) : 0,
                                    fee: obj.fee ? Number(obj.fee) : 0,
                                    feeCoin: obj.fee_coin,
                                    source: "",
                                },
                            };
                        })
                        : [],
                    round: item.round,
                    base: item.base,
                    baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(item.base),
                    startTime: item.start_time,
                    finishTime: item.finish_time,
                    status: item.status,
                    adjustInvestment: (_b = item.adjust_investment) !== null && _b !== void 0 ? _b : "",
                    adjustInvestmentAmount: (_c = item.adjust_investment_amount) !== null && _c !== void 0 ? _c : "0",
                    adjustInvestmentNominalAmount: (_d = item.adjust_investment_nominal_amount) !== null && _d !== void 0 ? _d : "0",
                    takeProfitTrailingMaxPrice: (_e = item.take_profit_trailing_max_price) !== null && _e !== void 0 ? _e : null,
                    priceScaleTrailingMinPrice: (_f = item.price_scale_trailing_min_price) !== null && _f !== void 0 ? _f : null,
                    takeProfitTriggerPrice: (_g = item === null || item === void 0 ? void 0 : item.take_profit_trigger_price) !== null && _g !== void 0 ? _g : null,
                    priceScaleTriggerPrice: (_h = item === null || item === void 0 ? void 0 : item.price_scale_trigger_price) !== null && _h !== void 0 ? _h : null,
                };
            }
            else {
                return undefined;
            }
        }));
    }
    /**
     * 查询多币MTG 当前挂单
     * @param orderId
     */
    queryMTGMultiModeCurrentRounds(orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/current_rounds/`;
        return trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, true).pipe((0, operators_1.map)((value) => {
            const items = value;
            if (items) {
                return items.current_rounds.map((item) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    return {
                        exchangeOrders: item.exchange_orders
                            ? (_a = item.exchange_orders) === null || _a === void 0 ? void 0 : _a.map((obj) => {
                                const symbolInfo = this.symbolMap.get(`${obj.base}_${obj.quote}`);
                                return {
                                    id: obj.exchange_order_id,
                                    orderType: obj.type,
                                    base: obj.base,
                                    quote: obj.quote,
                                    symbol: obj.symbol,
                                    timestamp: obj.timestamp,
                                    tag: obj.tag,
                                    state: TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0),
                                    baseDisplay: symbolInfo ? symbolInfo.baseDisplay : obj.base,
                                    isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                                    isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0)),
                                    originOrderData: obj,
                                    exchangeCustomOrder: {
                                        side: obj.side,
                                        type: obj.type,
                                        price: Number(obj.price),
                                        amount: Number(obj.amount),
                                        filled_amount: obj.filled ? Number(obj.filled) : 0,
                                        avgDealPrice: obj.average ? Number(obj.average) : 0,
                                        filled_value: obj.cost ? Number(obj.cost) : 0,
                                        feeInQuote: obj.fee_in_quote ? Number(obj.fee_in_quote) : 0,
                                        fee: obj.fee ? Number(obj.fee) : 0,
                                        feeCoin: obj.fee_coin,
                                        source: "",
                                    },
                                };
                            })
                            : [],
                        round: item.round,
                        base: item.base,
                        baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(item.base),
                        startTime: item.start_time,
                        finishTime: item.finish_time,
                        status: item.status,
                        adjustInvestment: (_b = item.adjust_investment) !== null && _b !== void 0 ? _b : "",
                        adjustInvestmentAmount: (_c = item.adjust_investment_amount) !== null && _c !== void 0 ? _c : "0",
                        adjustInvestmentNominalAmount: (_d = item.adjust_investment_nominal_amount) !== null && _d !== void 0 ? _d : "0",
                        takeProfitTrailingMaxPrice: (_e = item.take_profit_trailing_max_price) !== null && _e !== void 0 ? _e : null,
                        priceScaleTrailingMinPrice: (_f = item.price_scale_trailing_min_price) !== null && _f !== void 0 ? _f : null,
                        takeProfitTriggerPrice: (_g = item === null || item === void 0 ? void 0 : item.take_profit_trigger_price) !== null && _g !== void 0 ? _g : null,
                        priceScaleTriggerPrice: (_h = item === null || item === void 0 ? void 0 : item.price_scale_trigger_price) !== null && _h !== void 0 ? _h : null,
                        maxInvestQuote: (_j = item === null || item === void 0 ? void 0 : item.max_invest_quote) !== null && _j !== void 0 ? _j : "",
                        filledPercent: (_k = item === null || item === void 0 ? void 0 : item.filled_percent) !== null && _k !== void 0 ? _k : "",
                        takeProfitRatio: item.take_profit_ratio,
                        lossStopRatio: item.loss_stop_ratio,
                    };
                });
            }
            else {
                return undefined;
            }
        }));
    }
    /**
     * 查询MTG 历史挂单
     * @param param
     */
    queryMTGRoundList(param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${param.orderId}/rounds/`;
        const params = Object.assign({}, param);
        if (param.pageToken) {
            params.page_token = param.pageToken;
            delete params.pageToken;
        }
        return trade_utils_lib_1.ObservableUtils.get(url, params, undefined, true).pipe((0, operators_1.map)((value) => {
            const result = value;
            const orderList = result.results.map((item) => {
                return {
                    exchangeOrders: item.exchange_orders.map((obj) => {
                        const symbolInfo = this.symbolMap.get(`${obj.base}_${obj.quote}`);
                        return {
                            id: obj.exchange_order_id,
                            orderType: obj.type,
                            base: obj.base,
                            quote: obj.quote,
                            symbol: obj.symbol,
                            timestamp: obj.timestamp,
                            lastTradeTime: obj.lastTradeTimestamp,
                            tag: obj.tag,
                            state: TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0),
                            baseDisplay: symbolInfo ? symbolInfo.baseDisplay : obj.base,
                            isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                            isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0)),
                            originOrderData: obj,
                            exchangeCustomOrder: {
                                side: obj.side,
                                type: obj.type,
                                price: Number(obj.price),
                                amount: Number(obj.amount),
                                filled_amount: obj.filled ? Number(obj.filled) : 0,
                                filled_value: obj.cost ? Number(obj.cost) : 0,
                                avgDealPrice: obj.average ? Number(obj.average) : 0,
                                feeInQuote: obj.fee_in_quote ? Number(obj.fee_in_quote) : 0,
                                fee: obj.fee,
                                feeCoin: obj.fee_coin ? obj.fee_coin.toUpperCase() : "",
                                feeRefund: obj.fee_income_cost,
                                feeRefundCoin: obj.fee_income_coin ? obj.fee_income_coin.toUpperCase() : "",
                                source: "",
                            },
                        };
                    }),
                    round: item.round,
                    base: item.base,
                    baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(item.base),
                    startTime: item.start_time,
                    finishTime: item.finish_time,
                    status: item.status,
                    adjustInvestment: item.adjust_investment,
                    adjustInvestmentAmount: item.adjust_investment_amount,
                    adjustInvestmentNominalAmount: item.adjust_investment_nominal_amount,
                };
            });
            return {
                nextPageToken: "next_page_token" in result ? result["next_page_token"] : null,
                pairedOrderList: orderList,
            };
        }));
    }
    /**
     * 查询MTG 当前挂单
     * @param orderId
     */
    queryMTGFuturesCurrentRound(orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/futures_martingale/${orderId}/current_round/`;
        return trade_utils_lib_1.Network.get({
            url,
            authType: trade_utils_lib_1.AuthType.FullToken,
        }).pipe((0, operators_1.map)((value) => {
            var _a;
            const item = value;
            if (item) {
                return {
                    exchangeOrders: item.exchange_orders
                        ? (_a = item.exchange_orders) === null || _a === void 0 ? void 0 : _a.map((obj) => {
                            const symbolInfo = this.symbolMap.get(`${obj.base}_${obj.quote}`);
                            return {
                                id: obj.exchange_order_id,
                                orderType: obj.type,
                                base: obj.base,
                                quote: obj.quote,
                                symbol: obj.symbol,
                                timestamp: obj.timestamp,
                                tag: obj.tag,
                                state: TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0),
                                baseDisplay: symbolInfo ? symbolInfo.baseDisplay : obj.base,
                                isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                                isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0)),
                                originOrderData: obj,
                                exchangeCustomOrder: {
                                    side: obj.side,
                                    type: obj.type,
                                    price: Number(obj.price),
                                    amount: Number(obj.amount),
                                    filled_amount: obj.filled ? Number(obj.filled) : 0,
                                    avgDealPrice: obj.average ? Number(obj.average) : 0,
                                    filled_value: obj.cost ? Number(obj.cost) : 0,
                                    feeInQuote: obj.fee_in_quote ? Number(obj.fee_in_quote) : 0,
                                    fee: obj.fee ? Number(obj.fee) : 0,
                                    feeCoin: obj.fee_coin,
                                    source: "",
                                },
                            };
                        })
                        : [],
                    round: item.num,
                    base: item.base,
                    baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(item.base),
                    startTime: item.start_time,
                    finishTime: item.finish_time,
                    status: item.status,
                    profitStop: item.profit_stop,
                    lossStop: item.loss_stop,
                };
            }
            else {
                return undefined;
            }
        }));
    }
    /**
     * 查询合约马丁 历史挂单
     */
    queryMTGFuturesRoundList(param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/futures_martingale/${param.orderId}/rounds/`;
        const params = Object.assign({}, param);
        if (param.pageToken) {
            params.page_token = param.pageToken;
            delete params.pageToken;
        }
        return trade_utils_lib_1.Network.get({
            url,
            data: params,
            authType: trade_utils_lib_1.AuthType.FullToken,
        }).pipe((0, operators_1.map)((value) => {
            const result = value;
            const orderList = result.results.map((item) => {
                return {
                    exchangeOrders: item.exchange_orders.map((obj) => {
                        const symbolInfo = this.symbolMap.get(`${obj.base}_${obj.quote}`);
                        return {
                            id: obj.exchange_order_id,
                            orderType: obj.type,
                            base: obj.base,
                            quote: obj.quote,
                            symbol: obj.symbol,
                            timestamp: obj.timestamp,
                            lastTradeTime: obj.last_trade_timestamp,
                            tag: obj.tag,
                            state: TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0),
                            baseDisplay: symbolInfo ? symbolInfo.baseDisplay : obj.base,
                            isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                            isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(obj.status, (obj.filled ? obj.filled : 0) > 0)),
                            originOrderData: obj,
                            exchangeCustomOrder: {
                                side: obj.side,
                                type: obj.type,
                                price: Number(obj.price),
                                amount: Number(obj.amount),
                                filled_amount: obj.filled ? Number(obj.filled) : 0,
                                filled_value: obj.cost ? Number(obj.cost) : 0,
                                avgDealPrice: obj.average ? Number(obj.average) : 0,
                                feeInQuote: obj.fee_in_quote ? Number(obj.fee_in_quote) : 0,
                                fee: obj.fee,
                                feeCoin: obj.fee_coin ? obj.fee_coin.toUpperCase() : "",
                                feeRefund: obj.fee_income_cost,
                                feeRefundCoin: obj.fee_income_coin ? obj.fee_income_coin.toUpperCase() : "",
                                source: "",
                            },
                        };
                    }),
                    round: item.num,
                    base: item.base,
                    baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(item.base),
                    startTime: item.start_time,
                    finishTime: item.finish_time,
                    status: item.status,
                    profitStop: item.profit_stop,
                    lossStop: item.loss_stop,
                };
            });
            return {
                nextPageToken: "next_page_token" in result ? result["next_page_token"] : null,
                pairedOrderList: orderList,
            };
        }));
    }
    /**
     * 根据id 查询order
     * @param orderId
     */
    queryBotOrderInfo(orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderId}/`;
        return trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, true).pipe((0, operators_1.map)((result) => {
            return TradeUtils_1.TradeUtils.convertToExchangeOrder(result);
        }));
    }
    patchFSAAutoSettle(autoSettle, orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/cm_fsa/${orderId}/`;
        return (0, trade_utils_lib_1.getTradeDependencyInstance)()
            .getAccessToken()
            .pipe((0, operators_1.mergeMap)((token) => {
            const header = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json;charset=UTF-8",
            };
            return trade_utils_lib_1.ObservableUtils.createPatchRequestObservable(url, header, { auto_settlement: autoSettle }, (response) => {
                return response;
            });
        }));
    }
    configureMartingaleStopPriceRange(orderId, base, range) {
        const parseParams = {
            base: base,
            stop_scaling_price: range.stop_scaling_price !== undefined ? range.stop_scaling_price || "0" : undefined,
            stop_scaling_price_bottom: range.stop_scaling_price_bottom !== undefined ? range.stop_scaling_price_bottom || "0" : undefined,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/stop_scaling_price/`;
        return trade_utils_lib_1.ObservableUtils.post(url, parseParams, undefined, true);
    }
    setMartingaleStopPrice(orderId, base, modifyPriceType, modifyValue) {
        if (modifyPriceType === TradeTypeDef_1.MartingaleParamPriceType.stopScalePrice) {
            // 废弃
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/stop_scaling_price/`;
            return trade_utils_lib_1.ObservableUtils.post(url, { base: base, stop_scaling_price: modifyValue !== null && modifyValue !== void 0 ? modifyValue : "0" }, undefined, true);
        }
        else {
            const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/update_stop_percentage/`;
            let requestBody = {};
            if (modifyPriceType === TradeTypeDef_1.MartingaleParamPriceType.takeProfitPercentage) {
                requestBody = { stop_profit_percentage: modifyValue !== null && modifyValue !== void 0 ? modifyValue : null };
            }
            else if (modifyPriceType === TradeTypeDef_1.MartingaleParamPriceType.stopLossPercentage) {
                requestBody = { stop_loss_percentage: modifyValue !== null && modifyValue !== void 0 ? modifyValue : null, unrealized_stop_loss_percentage: null };
            }
            else if (modifyPriceType === TradeTypeDef_1.MartingaleParamPriceType.stopLossBaseUnrealizedProfit) {
                requestBody = { unrealized_stop_loss_percentage: modifyValue !== null && modifyValue !== void 0 ? modifyValue : null, stop_loss_percentage: null };
            }
            return trade_utils_lib_1.ObservableUtils.post(url, requestBody, undefined, true);
        }
    }
    requestMTGAIStrategyWithSymbol(base, quote) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/ai_param/`;
        return trade_utils_lib_1.ObservableUtils.get(url, { base: base, quote: quote }, undefined, true).pipe((0, operators_1.map)((result) => {
            var _a;
            return (_a = result.strategies) !== null && _a !== void 0 ? _a : [];
        }));
    }
    /**
     * 多币马丁AI参数
     * @param pairs
     */
    requestMTGMultiAIStrategyWithSymbols(pairs) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/ai_params/`;
        return trade_utils_lib_1.ObservableUtils.post(url, { symbols: pairs }, undefined, true).pipe((0, operators_1.map)((result) => {
            return result !== null && result !== void 0 ? result : [];
        }));
    }
    /**
     * 多币马丁最小投资额
     * @param param
     */
    queryMTGMultiMinInvest(param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/multi_min_invest/`;
        return trade_utils_lib_1.ObservableUtils.post(url, param, undefined, true).pipe((0, operators_1.map)((result) => {
            var _a;
            return (_a = result.total_need_invest) !== null && _a !== void 0 ? _a : "";
        }));
    }
    renewMartingale(orderId, base) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/renew_round/`;
        return trade_utils_lib_1.ObservableUtils.post(url, base ? { base } : undefined, undefined, true);
    }
    modifyBotOrderNote(orderId, note, orderType) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderId}/note/`;
        const supportNewAPI = [
            TradeTypeDef_1.ExchangeOrderType.gridV5,
            TradeTypeDef_1.ExchangeOrderType.copy_bot,
            TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
            TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
            TradeTypeDef_1.ExchangeOrderType.futures_martingale,
        ];
        if (orderType && supportNewAPI.includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/note/`;
        }
        return trade_utils_lib_1.Network.post({ url, data: { note: note }, authType: trade_utils_lib_1.AuthType.Access });
    }
    modifySRPriceInfo(param, orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_rebalance/${orderId}/update_loss_profit_stop/`;
        return trade_utils_lib_1.ObservableUtils.post(url, param, undefined, true);
    }
    editStopRatio(data, orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/martingale/${orderId}/edit_stop_ratio/`;
        return trade_utils_lib_1.NetworkUtils.post({
            authorize: true,
            url,
            data,
        });
    }
    idleFunds(orderId, orderType = TradeTypeDef_1.ExchangeOrderType.martingale) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/idle_funds/`;
        const params = {
            url,
            authType: trade_utils_lib_1.AuthType.Access,
        };
        if (orderType === TradeTypeDef_1.ExchangeOrderType.futures_smart_trade) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/idle_funds/`;
            params.url = url;
            params.authType = trade_utils_lib_1.AuthType.FullToken;
        }
        return trade_utils_lib_1.Network.get(params);
    }
    queryIdleFunds(orderId, orderType) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/idle_funds/`;
        const params = {
            url,
            authType: trade_utils_lib_1.AuthType.FullToken,
        };
        return trade_utils_lib_1.Network.get(params);
    }
    setGridPause(orderId, orderType, data) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/pause/`;
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/pause/`;
        }
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4Futures) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/pause/`;
        }
        const params = orderType === TradeTypeDef_1.ExchangeOrderType.gridV4Futures && data ? data : {};
        return trade_utils_lib_1.Network.post({ url, data: params, authType: trade_utils_lib_1.AuthType.Access });
    }
    setGridResume(orderId, orderType) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/resume/`;
        if ([TradeTypeDef_1.ExchangeOrderType.gridV5, TradeTypeDef_1.ExchangeOrderType.gridV4Futures].includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/resume/`;
        }
        return trade_utils_lib_1.Network.post({ url, data: {}, authType: trade_utils_lib_1.AuthType.Access });
    }
    saveOrderFavParams(type, title, data) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/favourite/`;
        const params = {
            favourite_type: type,
            title: title,
            data: data,
        };
        return trade_utils_lib_1.ObservableUtils.post(url, params, undefined, true);
    }
    deleteOrderFavParams(id, type) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/favourite/${id}/`;
        return trade_utils_lib_1.ObservableUtils.delete(url, { favourite_type: type }, undefined, true);
    }
    orderFavParamsList(type) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/favourite/`;
        return trade_utils_lib_1.ObservableUtils.get(url, { favourite_type: type }, undefined, true);
    }
    queryGridMinAddPosition(param, orderType) {
        // 参数不支持空串
        const params = {
            bu_order_type: param.bu_order_type,
            base: param.symbol.base,
            quote: param.symbol.quote,
            exchange: param.market,
            base_total_investment: param.base_total_investment || null,
            quote_total_investment: param.quote_total_investment || null,
            top: param.top,
            bottom: param.bottom,
            row: param.row,
            earn_coin: param.earn_coin,
            trend: param.trend,
            grid_type: param.grid_type,
            loss_stop: param.loss_stop || null,
            profit_stop: param.profit_stop || null,
            precision: {
                amount: param.symbol.amount,
                price: param.symbol.precision,
            },
            limits: param.symbol.limit,
            leverage: param.leverage || null,
            per_volume: param.per_volume || null,
            open_price: param.open_price || null,
            condition: param.condition || null,
            condition_direction: param.condition_direction || null,
            fee_rate: param.fee_rate || null,
        };
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/${orderType}/min_overweight`;
        return trade_utils_lib_1.ObservableUtils.post(url, JSON.stringify(params), null);
    }
    queryGridPositionRecordList(orderId, orderType) {
        let url = "";
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/adjust_record_list/`;
        }
        else {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/adjust_record_list/`;
        }
        return trade_utils_lib_1.Network.get({ url, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((result) => {
            return result.reverse();
        }));
    }
    queryGridPositionRecordListV2(param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${param.orderType}/${param.orderId}/adjust_record_list/`;
        return trade_utils_lib_1.Network.get({
            url,
            data: { page_token: param.next_page_token },
            needBearer: true,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((result) => {
            return {
                next_page_token: result.next_page_token,
                results: result.results,
            };
        }));
    }
    queryGridReinvestList(param) {
        const { orderId, orderType } = param, rest = __rest(param, ["orderId", "orderType"]);
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/reinvest_list/`;
        if (param.orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${param.orderType}/${param.orderId}/reinvest_list/`;
        }
        return trade_utils_lib_1.Network.get({
            url,
            data: rest,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((data) => {
            return Object.assign(Object.assign({}, data), { results: data === null || data === void 0 ? void 0 : data.results });
        }));
    }
    switchProfitAutoReinvest(param) {
        const { orderId, orderType } = param, rest = __rest(param, ["orderId", "orderType"]);
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/profit_auto_reinvest/`;
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/profit_auto_reinvest/`;
        }
        return trade_utils_lib_1.Network.post({ url, data: rest, authType: trade_utils_lib_1.AuthType.Access });
    }
    queryOrderShareID(orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/order_share/`;
        return trade_utils_lib_1.ObservableUtils.post(url, { bu_order_id: orderId }, null, true);
    }
    queryOrderShare(shareId, ignoreParseOrderTypes) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/order_share/${shareId}`;
        return trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, false).pipe((0, operators_1.map)((data) => {
            if (!data) {
                throw { code: -1, message: "no data" };
            }
            if (!ignoreParseOrderTypes || !ignoreParseOrderTypes.includes(data.bu_order.bu_order_type)) {
                const parseOrder = TradeUtils_1.TradeUtils.convertToExchangeOrder(data.bu_order);
                data.parseOrder = parseOrder;
                data.parseOrder.id = data.bu_order_id;
            }
            return data;
        }));
    }
    gridAdjustParams(param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${param.orderType}/${param.orderId}/adjust_params/`;
        return trade_utils_lib_1.ObservableUtils.post(url, param.params, null, true);
    }
    /**
     * gridv4网格订单修改参数
     * @param param
     */
    gridV4AdjustParams(param) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${param.orderType}/${param.orderId}/adjust_params/`;
        let data = param.params;
        if (param.orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${param.orderType}/${param.orderId}/adjust_params/`;
            // @ts-ignore
            data = Object.assign(Object.assign({}, param.params), { row: Number(param.params.row) });
        }
        return trade_utils_lib_1.Network.post({
            url,
            data: data,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    querySignalList(orderType, base, quote, signal_type) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/list`;
        const params = { bu_order_type: orderType, base: base, quote: quote };
        if (signal_type) {
            params["signal_type"] = signal_type;
        }
        return trade_utils_lib_1.ObservableUtils.getV2(url, params, null, true);
    }
    /**
     * 查询策略可用的信号
     * 如果要拿币对去筛选就传，然后不要传filter_option_all_symbols（或者传false） （已编辑）
     * 9:40
     * 如果不筛选，要拿所有，就传filter_option_all_symbols=true
     */
    queryMultiCoinsSignalList(orderType, symbols, filter_option_all_symbols, signal_type) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/multi_list`;
        const params = {
            bu_order_type: orderType,
            symbols: symbols,
            filter_option_all_symbols: filter_option_all_symbols !== null && filter_option_all_symbols !== void 0 ? filter_option_all_symbols : false,
        };
        if (signal_type) {
            params["signal_type"] = signal_type;
        }
        return trade_utils_lib_1.ObservableUtils.postV2(url, params, null, true);
    }
    /**
     * 查询信号详情
     * @param signal_type
     */
    querySignalDetail(signal_type) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/detail`;
        return trade_utils_lib_1.ObservableUtils.get(url, { signal_type: signal_type }, null, false);
    }
    queryVolatilityRank(param) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/indicator/hv/rank/`;
        const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(param.exchange);
        return trade_utils_lib_1.ObservableUtils.get(url, param, null, false).pipe((0, operators_1.map)((data) => {
            if (data) {
                if (data.list) {
                    return data.list.map((a) => {
                        const temp = TradeUtils_1.TradeUtils.parseDisplay(a.base, a.quote, param.exchange);
                        return {
                            rank: a.rank,
                            base: a.base,
                            quote: a.quote,
                            baseDisplay: temp.baseDisplay,
                            volatility: a.value,
                        };
                    });
                }
                else {
                    return undefined;
                }
            }
            else {
                throw { code: -1, message: "no data" };
            }
        }));
    }
    /**
     * 查询KOL策略列表
     * @param lang
     * @param page_token
     * @param condition
     * @param category
     * @param enable_all_period
     * @param authorize
     */
    queryKolStrategy(lang, page_token, condition, category, enable_all_period, authorize) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/`;
        const param = {};
        if (lang) {
            param.lang = lang;
        }
        if (page_token) {
            param.page_token = page_token;
        }
        if (condition) {
            param.condition = condition;
        }
        if (category) {
            param.category = category;
        }
        if (enable_all_period) {
            param.enable_all_period = enable_all_period;
        }
        return trade_utils_lib_1.ObservableUtils.get(url, param, null, authorize).pipe((0, operators_1.map)((data) => {
            var _a;
            return {
                page_token: data.page_token,
                signals: data.signals
                    ? (_a = data.signals) === null || _a === void 0 ? void 0 : _a.map((a) => {
                        return Object.assign(Object.assign({}, a), { properties: JSON.stringify(a.properties) });
                    })
                    : [],
            };
        }));
    }
    /**
     * 查询KOL策略信号列表
     * @param strategyId
     * @param page_token
     */
    queryKolStrategySignals(strategyId, page_token) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/alert/`;
        const param = {};
        if (page_token) {
            param.page_token = page_token;
        }
        const currentDate = new Date().getTime();
        return trade_utils_lib_1.ObservableUtils.getV2(url, param, null, true).pipe((0, operators_1.map)((data) => {
            var _a;
            return Object.assign(Object.assign({}, data), { alerts: data.alerts
                    ? (_a = data.alerts) === null || _a === void 0 ? void 0 : _a.map((a) => {
                        return Object.assign(Object.assign({}, a), { is24HourAgo: Math.abs(a.time - currentDate) > 86400000 });
                    })
                    : [] });
        }));
    }
    /**
     * 查询KOL策略历史信号列表
     * @param strategyId
     * @param symbol
     * @param lang
     */
    queryKolStrategyHistorySignals(strategyId, symbol, lang) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/history_alert/?lang=${lang}`;
        const param = {};
        param.symbols = symbol.map((a) => `${a.base}_${a.quote}`);
        const currentDate = new Date().getTime();
        return trade_utils_lib_1.ObservableUtils.postV2(url, param, null, true);
    }
    /**
     * 查询KOL策略信号详情
     * @param strategyId
     * @param lang
     * @param enable_all_period
     */
    queryKolStrategyDetail(strategyId, lang, enable_all_period) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/`;
        const param = {};
        param.lang = lang;
        if (enable_all_period) {
            param.enable_all_period = enable_all_period;
        }
        return trade_utils_lib_1.ObservableUtils.get(url, param, null, false).pipe((0, operators_1.map)((data) => {
            return Object.assign(Object.assign({}, data), { properties: JSON.stringify(data.properties) });
        }));
    }
    /**
     * 修改KOL信号通知 下面参数二选一
     * @param strategyId
     * @param signalId
     * @param bu_order_id
     * @param bu_order_type
     */
    updateStrategySignals(strategyId, signalId, bu_order_id, bu_order_type) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/alert/`;
        const param = { alert_id: signalId, bu_order_id: bu_order_id, bu_order_type: bu_order_type };
        return trade_utils_lib_1.ObservableUtils.postV2(url, param, null, true);
    }
    /**
     * 订阅kol信号
     * @param strategyId
     * @param symbol
     */
    subscribeStrategySignals(strategyId, symbol) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/subscription/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, { symbols: symbol }, null, true);
    }
    /**
     * 取消订阅kol信号
     * @param strategyId
     */
    unsubscribeStrategySignals(strategyId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/subscription/`;
        return trade_utils_lib_1.ObservableUtils.delete(url, {}, null, true);
    }
    /**
     *  更新kol 信号订阅币对
     * @param strategyId
     * @param symbol
     */
    updateSubscribeStrategySignals(strategyId, symbol) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/subscription/update/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, { symbols: symbol }, null, true);
    }
    /**
     * 获取策略信号收益表现图表详情
     * @param strategyId
     * @param period
     */
    queryStrategyPerformance(strategyId, period) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/performance/`;
        return trade_utils_lib_1.ObservableUtils.get(url, { period: period }, null, false).pipe((0, operators_1.map)((data) => {
            return {
                kol_signal_id: data.kol_signal_id,
                period: data.period,
                values: data.values.data,
            };
        }));
    }
    /**
     * 查询订阅信号详情
     * @param strategyId
     */
    queryStrategySubscriptionInfo(strategyId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/subscription/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, {}, null, true);
    }
    /**
     * 查询特定的信号
     * @param strategyId
     * @param params
     */
    queryStrategySignal(strategyId, params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/previous_alert/`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, params, null, true).pipe((0, operators_1.map)((data) => {
            const currentDate = new Date().getTime();
            return Object.assign(Object.assign({}, data), { is24HourAgo: Math.abs(data.time - currentDate) > 86400000 });
        }));
    }
    /**
     * 通过信号id查询定的信号
     * @param strategyId
     * @param signalId
     */
    queryStrategySignalById(strategyId, signalId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().signalHost}/signal/kol_signal/${strategyId}/alert/${signalId}`;
        return trade_utils_lib_1.ObservableUtils.getV2(url, {}, null, true).pipe((0, operators_1.map)((data) => {
            const currentDate = new Date().getTime();
            return Object.assign(Object.assign({}, data), { is24HourAgo: Math.abs(data.time - currentDate) > 86400000 });
        }));
    }
    /**
     * 查询策略跟单历史交易记录
     * @param params
     */
    querySmartCopyRounds(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_copy/${params.orderId}/rounds/`;
        const param = params.pageToken ? { page_token: params.pageToken } : {};
        // if (params.base) {
        //     params = { base: params.base };
        // }
        return trade_utils_lib_1.ObservableUtils.get(url, param, undefined, true).pipe((0, operators_1.map)((value) => {
            const result = value;
            const orderList = result.results.map((item) => {
                return {
                    exchangeOrders: item.alert_orders.map((obj) => {
                        const symbolInfo = this.symbolMap.get(`${obj.base}_${item.quote}`);
                        return {
                            id: obj.bu_order_id,
                            orderType: TradeTypeDef_1.ExchangeOrderType.limit,
                            base: obj.base,
                            quote: item.quote,
                            symbol: obj.symbol,
                            timestamp: obj.create_time,
                            state: TradeTypeDef_1.ExchangeOrderStatus.closed,
                            baseDisplay: symbolInfo ? symbolInfo.baseDisplay : obj.base,
                            isLeverage: symbolInfo ? symbolInfo.isLeverage : false,
                            isRunning: false,
                            originOrderData: obj,
                            exchangeCustomOrder: {
                                side: obj.side,
                                type: TradeTypeDef_1.ExchangeOrderType.limit,
                                price: Number(obj.alert_price),
                                amount: Number(obj.amount),
                                filled_amount: obj.traded_amount ? Number(obj.traded_amount) : 0,
                                filled_value: obj.traded_cost ? Number(obj.traded_cost) : 0,
                                avgDealPrice: obj.average_price ? Number(obj.average_price) : 0,
                                feeInQuote: obj.fee_in_quote ? Number(obj.fee_in_quote) : 0,
                                fee: obj.fee,
                                feeCoin: obj.fee_coin ? obj.fee_coin.toUpperCase() : "",
                                source: "",
                                triggerSource: obj.trigger_source,
                            },
                        };
                    }),
                    round: item.round,
                    base: item.base,
                    quote: item.quote,
                    baseDisplay: TradeUtils_1.TradeUtils.parseBaseDisplay(item.base),
                    startTime: item.start_time,
                    finishTime: item.finish_time,
                    status: item.status,
                    profit: item.profit,
                    nominalLeverage: item.nominal_leverage,
                };
            });
            return {
                nextPageToken: "next_page_token" in result ? result["next_page_token"] : null,
                pairedOrderList: orderList,
            };
        }));
    }
    /**
     * 修改策略跟单是否开启复利
     * @param params
     */
    modifySmartCopyCompound(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_copy/${params.orderId}/edit_compound/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, { compound: !!params.compound }, undefined, true);
    }
    /**
     * 策略跟单 手动平仓
     */
    manuallyLiquidateSCPosition(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_copy/${params.orderId}/manual/`;
        return trade_utils_lib_1.ObservableUtils.postV2(url, {}, undefined, true);
    }
    /**
     * 修改网格的移动网格配置
     * @param params
     * @param orderId
     * @param orderType
     */
    modifyGridMovingOption(params, orderId, orderType) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/moving_grid_option/`;
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/moving_grid_option/`;
        }
        const body = {
            moving_indicator_type: params.movingIndicatorType,
            moving_indicator_interval: params.movingIndicatorInterval,
            moving_indicator_param: params.movingIndicatorParam,
            moving_trailing_up_param: params.movingTrailingUpParam,
        };
        return trade_utils_lib_1.Network.post({
            url,
            data: new trade_utils_lib_1.SafeDecimal(params.movingTrailingUpParam).equals(0) ? {} : body,
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((v) => {
            return {
                movingIndicatorType: v.moving_indicator_type,
                movingIndicatorInterval: v.moving_indicator_interval,
                movingIndicatorParam: v.moving_indicator_param,
                movingTrailingUpParam: v.moving_trailing_up_param,
            };
        }));
    }
    /**
     * 获取最大单网格买入量
     * @param params
     * @param orderType
     */
    queryGridMaxPerVolume(params, orderType) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/max_per_volume/`;
        if (orderType === TradeTypeDef_1.ExchangeOrderType.gridV5) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/max_per_volume/`;
        }
        return trade_utils_lib_1.Network.get({ url, data: params, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((data) => data.per_volume));
    }
    /**
     * 获取AI策略列表
     * @param params
     */
    queryGridV4AiStrategyList(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/grid_v4/ai_strategy/`;
        return trade_utils_lib_1.Network.get({ url, data: params, authType: trade_utils_lib_1.AuthType.Access });
    }
    queryGridV5AiStrategyList(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/grid_v5/ai_strategy/`;
        return trade_utils_lib_1.Network.get({ url, data: params, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * @description: 修改机器人 订单名称
     * @param {string} name
     * @param {ExchangeOrderType} orderType
     * @param {string} orderId
     * @return {*}
     */
    modifyOrderBotName(name, orderType, orderId) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/${orderType}/${orderId}/customize_name/`;
        const body = {
            customize_name: name,
        };
        if ([
            TradeTypeDef_1.ExchangeOrderType.gridV5,
            TradeTypeDef_1.ExchangeOrderType.copy_bot,
            TradeTypeDef_1.ExchangeOrderType.gridV4Futures,
            TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
            TradeTypeDef_1.ExchangeOrderType.futures_martingale,
        ].includes(orderType)) {
            url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/customize_name/`;
        }
        return trade_utils_lib_1.Network.post({ url, data: body, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * 修改策略跟单止盈止损比例
     * @param param
     * @param orderId
     * @returns
     */
    modifySCStopRatio(param, orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_copy/${orderId}/edit_stop_ratio/`;
        return trade_utils_lib_1.ObservableUtils.post(url, param, undefined, true);
    }
    /**
     * 订单分组创建
     * @param params
     */
    createOrderGroup(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/order_group/`;
        return trade_utils_lib_1.Network.post({ url, data: params, headers: undefined, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * 订单分组修改绑定数组
     * @param params
     * @constructor
     */
    OrderGroupBindOrder(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/order_group/${params.group_id}/bind/`;
        delete params.group_id;
        return trade_utils_lib_1.Network.post({ url, data: params, headers: undefined, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * 订单分组解绑
     * @param group_id
     * @constructor
     */
    OrderGroupUnBindOrder(group_id) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/order_group/${group_id}/unbind/`;
        return trade_utils_lib_1.Network.post({ url, data: undefined, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * 支持订单分组的bot订单列表
     * @param params
     */
    queryAllBotOrdersV5(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/orders/`;
        let urlParam = {};
        if (params.orderTypes) {
            urlParam.bu_order_types = params.orderTypes.toString();
        }
        if (params.exchange) {
            urlParam.exchange = params.exchange;
        }
        if (params.status) {
            urlParam.status = params.status;
        }
        if (params.pageToken) {
            urlParam.page_token = params.pageToken;
        }
        if (params.pair) {
            urlParam.base = params.pair.base;
            urlParam.quote = params.pair.quote;
        }
        if (params.copyType) {
            urlParam.copy_type = params.copyType;
        }
        if (params.group_id) {
            urlParam.group_id = params.group_id;
        }
        return trade_utils_lib_1.Network.get({ url: url, data: urlParam, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((data) => {
            var _a, _b;
            const parseData = {
                nextPageToken: data.next_page_token,
                orders: (_b = (_a = data.results) === null || _a === void 0 ? void 0 : _a.map((item) => {
                    return TradeUtils_1.TradeUtils.convertToExchangeOrder(item);
                }).filter((item1) => item1 !== undefined)) !== null && _b !== void 0 ? _b : [],
            };
            return parseData;
        }), (0, operators_1.catchError)((error, e) => {
            if ((error === null || error === void 0 ? void 0 : error.code) === -10001) {
                (0, trade_token_lib_1.acquireKeyResolver)().tradingTokenManager.updateAccessToken();
            }
            return (0, rxjs_1.throwError)(error);
        }));
    }
    /**
     * 根据分组id查询分组内部订单列表
     * @param group_id
     * @param page_token
     * @param status
     */
    queryGroupOrderList(group_id, page_token, status) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/order_group/${group_id}/orders/`;
        let urlParam = {};
        if (page_token) {
            urlParam.page_token = page_token;
        }
        if (status) {
            urlParam.status = status;
        }
        else {
            urlParam.status = "running";
        }
        return trade_utils_lib_1.Network.get({ url, data: urlParam, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((data) => {
            var _a, _b;
            const parseData = {
                nextPageToken: data.next_page_token,
                orders: (_b = (_a = data.results) === null || _a === void 0 ? void 0 : _a.map((item) => {
                    return TradeUtils_1.TradeUtils.convertToExchangeOrder(item);
                }).filter((item1) => item1 !== undefined)) !== null && _b !== void 0 ? _b : [],
            };
            return parseData;
        }));
    }
    /**
     * 根据分组id查询分组详情
     * @param group_id
     */
    queryGroupOrderDetail(group_id) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/order_group/${group_id}/`;
        return trade_utils_lib_1.Network.get({ url, data: undefined, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((data) => {
            return TradeUtils_1.TradeUtils.convertToExchangeOrder(data);
        }));
    }
    /**
     * 仅通过通过id和type,取消订单
     * @param orderId
     * @param orderType
     * @param info
     */
    cancelOrderObservableById(orderId, orderType, info) {
        return this.cancelStrategyOrder(orderId, orderType, info);
    }
    /**
     * 查询bot策略单数量
     */
    queryBotOrderCountV2() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/orders/statistical/quantity/`;
        return trade_utils_lib_1.Network.get({ url, data: undefined, authType: trade_utils_lib_1.AuthType.Access }).pipe((0, operators_1.map)((data) => {
            var _a;
            return ((_a = data === null || data === void 0 ? void 0 : data.map((item) => {
                return {
                    orderType: item.bu_order_type,
                    count: item.num,
                };
            })) !== null && _a !== void 0 ? _a : []);
        }));
    }
    /**
     * 订单分组重命名
     * @param params
     */
    OrderGroupRenameOrder(params) {
        const { group_id } = params, rest = __rest(params, ["group_id"]);
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/order_group/${group_id}/rename/`;
        return trade_utils_lib_1.Network.post({ url, data: rest, headers: undefined, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * 获取可用额度
     * @param params
     */
    queryFSTMaxLimit(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/futures_smart_trade/limit/`;
        return trade_utils_lib_1.Network.post({ url, data: params, authType: trade_utils_lib_1.AuthType.FullToken });
    }
    /**
     * 修改触发价/止盈止损
     */
    editTriggerPrice(orderId, params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_grid_v4/${orderId}/trigger_price/`;
        return trade_utils_lib_1.Network.post({
            url,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * 修改触发价/止盈止损
     */
    editOrderTriggerPrice(params) {
        const { orderId, orderType } = params, restParams = __rest(params, ["orderId", "orderType"]);
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/trigger_price/`;
        return trade_utils_lib_1.Network.post({
            url,
            data: restParams,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * 更新自动跟单订单字段
     */
    editCopyBotOrderInfo(params) {
        const { orderId, orderType } = params, restParams = __rest(params, ["orderId", "orderType"]);
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/update/`;
        return trade_utils_lib_1.Network.post({
            url,
            data: restParams,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * 获取跟随者
     */
    getCopyBotOrderFollowers(params) {
        const { orderId, orderType } = params, restParams = __rest(params, ["orderId", "orderType"]);
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/followers/`;
        return trade_utils_lib_1.Network.get({
            url,
            data: restParams,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * 获取分润详情
     */
    getCopyBotOrderShareSettledProfit(params) {
        const { orderId, orderType } = params, restParams = __rest(params, ["orderId", "orderType"]);
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/share_settled_profits/`;
        return trade_utils_lib_1.Network.get({
            url,
            data: restParams,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * 获取操作记录
     */
    getCopyBotOrderOperationList(params) {
        const { orderId, orderType } = params, restParams = __rest(params, ["orderId", "orderType"]);
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${orderId}/operation_list/`;
        return trade_utils_lib_1.Network.get({
            url,
            data: restParams,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * 立即触发
     */
    orderImmediateTrigger(orderId, params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/future_grid_v4/${orderId}/immediate_trigger/`;
        return trade_utils_lib_1.Network.post({
            url,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    queryGridOverview(params) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/overview/`;
        return trade_utils_lib_1.Network.get({
            url,
            data: { period: params.period },
            authType: trade_utils_lib_1.AuthType.Access,
        }).pipe((0, operators_1.map)((res) => {
            return TradingBotResConvertUtils_1.TradingBotResConvertUtils.queryGridOverviewHandle(res);
        }));
    }
    queryEnhancedAipAdjustRecord(params) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/enhanced_aip/${params.bu_order_id}/adjust_record/`;
        return trade_utils_lib_1.Network.get({
            url,
            data: { page_token: params.page_token },
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    adjustEnhancedAipParams(params) {
        if (!params.base || !(params.interval || params.per_volume || params.price_limit)) {
            throw new Error("At least one params must be provided.");
        }
        const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST;
        const { bu_order_id } = params, other = __rest(params, ["bu_order_id"]);
        return trade_utils_lib_1.Network.post({
            url: `${host}/orders/enhanced_aip/${bu_order_id}/adjust_param/`,
            data: other,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    setGridCloseSellModel(params) {
        // 断言
        if (!params.close_sell_model && !params.close_sell_model_profit_stop && !params.close_sell_model_loss_stop) {
            throw new Error("At least one close_sell_model must be provided.");
        }
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${params.orderType}/${params.orderId}/close_sell_model/`;
        return trade_utils_lib_1.Network.post({
            url,
            data: {
                close_sell_model: params.close_sell_model,
                close_sell_model_profit_stop: params.close_sell_model_profit_stop,
                close_sell_model_loss_stop: params.close_sell_model_loss_stop,
            },
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    /**
     * @description: 获取可用订单数量额度 https://pionex.atlassian.net/wiki/spaces/backend/pages/50731121/smart+copy+API#%E8%8E%B7%E5%8F%96%E5%8F%AF%E7%94%A8%E8%AE%A2%E5%8D%95%E6%95%B0%E9%87%8F%E9%A2%9D%E5%BA%A6
     * @return {*}
     */
    fetchSmartCopyCheck() {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/smart_copy/available_limit/`;
        return trade_utils_lib_1.Network.get({ url, data: {}, authType: trade_utils_lib_1.AuthType.Access });
    }
    /**
     * 订单列表消息通知API文档 https://pionex.atlassian.net/wiki/x/yQG-Gg
     */
    fetchOrderNotificationList(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().kolTApi}/order_notification_list`;
        return trade_utils_lib_1.Network.post({
            url,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    copyBotOrderBatchClose(params) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/copy_bot/${params.orderId}/cancel_sub_orders/`;
        delete params.orderId;
        return trade_utils_lib_1.Network.post({
            url,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    queryCopyBotOverView(orderId) {
        const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/copy_bot/${orderId}/overview/`;
        return trade_utils_lib_1.Network.get({
            url,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
    queryCopyTransactionRecord(params) {
        let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/copy_bot/${params.bu_order_id}/copy_transactioned/`;
        delete params.bu_order_id;
        return trade_utils_lib_1.Network.get({
            url,
            data: params,
            authType: trade_utils_lib_1.AuthType.Access,
        });
    }
}
exports.default = BaseBotApiAdapter;
